import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withKeys as _withKeys, createTextVNode as _createTextVNode, vShow as _vShow, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "space-y-6" }
const _hoisted_2 = { class: "p-6 space-y-6" }
const _hoisted_3 = { class: "p-5 bg-gray-50 dark:bg-gray-700/50 rounded-xl" }
const _hoisted_4 = { class: "flex space-x-4" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "space-y-4" }
const _hoisted_7 = { class: "grid grid-cols-2 gap-5" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 0,
  class: "flex flex-wrap gap-2"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = {
  key: 1,
  class: "px-4 py-3 bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-xl"
}
const _hoisted_12 = { class: "flex items-start" }
const _hoisted_13 = { class: "flex-1 space-y-2" }
const _hoisted_14 = { class: "text-sm text-blue-600 dark:text-blue-400" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "text-sm text-emerald-600 dark:text-emerald-400 font-medium" }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "text-sm text-violet-600 dark:text-violet-400 font-medium" }
const _hoisted_19 = { class: "flex gap-4" }
const _hoisted_20 = { class: "flex items-center space-x-3" }
const _hoisted_21 = {
  key: 0,
  class: "text-xs font-mono text-gray-500 dark:text-gray-400 max-w-xs truncate"
}
const _hoisted_22 = ["disabled"]
const _hoisted_23 = {
  key: 0,
  class: "animate-spin h-3.5 w-3.5",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_24 = {
  key: 1,
  class: "h-3.5 w-3.5",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_25 = { class: "overflow-hidden" }
const _hoisted_26 = { class: "p-6 space-y-5" }
const _hoisted_27 = {
  key: 0,
  class: "flex justify-end space-x-2"
}
const _hoisted_28 = {
  key: 1,
  class: "p-5 bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-700 rounded-xl space-y-4"
}
const _hoisted_29 = { class: "flex items-center justify-between" }
const _hoisted_30 = ["onKeydown"]
const _hoisted_31 = {
  key: 0,
  class: "text-xs text-rose-500"
}
const _hoisted_32 = { class: "grid grid-cols-2 gap-5" }
const _hoisted_33 = { class: "space-y-3" }
const _hoisted_34 = ["onUpdate:modelValue"]
const _hoisted_35 = ["onUpdate:modelValue"]
const _hoisted_36 = ["onClick"]
const _hoisted_37 = {
  key: 0,
  class: "text-sm text-gray-500 dark:text-gray-400 italic py-2"
}
const _hoisted_38 = { key: 2 }
const _hoisted_39 = {
  key: 0,
  class: "mt-2 text-xs text-rose-500"
}
const _hoisted_40 = { class: "px-4 py-3 border-b border-gray-200 dark:border-gray-700 flex items-center justify-between" }
const _hoisted_41 = { class: "p-4 max-h-[600px] overflow-y-auto" }
const _hoisted_42 = {
  key: 0,
  class: "p-4 bg-rose-50 dark:bg-rose-900/20 border border-rose-200 dark:border-rose-700 rounded-xl"
}
const _hoisted_43 = { class: "flex items-start" }
const _hoisted_44 = { class: "flex-1" }
const _hoisted_45 = { class: "text-sm text-rose-600 dark:text-rose-400 mt-1" }
const _hoisted_46 = {
  key: 1,
  class: "space-y-3"
}
const _hoisted_47 = { class: "flex items-center justify-between" }
const _hoisted_48 = { class: "text-xs font-medium text-gray-500 dark:text-gray-400" }
const _hoisted_49 = { class: "text-blue-600 dark:text-blue-400" }
const _hoisted_50 = { class: "text-xs font-mono text-gray-800 dark:text-gray-200 overflow-x-auto whitespace-pre-wrap p-3 bg-gray-50 dark:bg-gray-700/50 rounded-lg border border-gray-200 dark:border-gray-600" }
const _hoisted_51 = { class: "flex gap-4" }
const _hoisted_52 = { class: "flex items-center space-x-3" }
const _hoisted_53 = {
  key: 0,
  class: "px-2 py-1 text-xs font-medium bg-amber-100 dark:bg-amber-900/30 text-amber-700 dark:text-amber-400 rounded-lg"
}
const _hoisted_54 = ["disabled"]
const _hoisted_55 = {
  key: 0,
  class: "animate-spin h-3.5 w-3.5",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_56 = {
  key: 1,
  class: "h-3.5 w-3.5",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_57 = { class: "overflow-hidden" }
const _hoisted_58 = { class: "p-6 space-y-5" }
const _hoisted_59 = { class: "flex items-center justify-between p-5 bg-gray-50 dark:bg-gray-700/50 rounded-xl" }
const _hoisted_60 = {
  key: 0,
  class: "p-5 bg-gray-50 dark:bg-gray-700/50 rounded-xl space-y-5 border border-gray-200 dark:border-gray-600"
}
const _hoisted_61 = { class: "grid grid-cols-2 gap-5" }
const _hoisted_62 = { class: "grid grid-cols-2 gap-5" }
const _hoisted_63 = { class: "pt-4 border-t border-gray-200 dark:border-gray-600" }
const _hoisted_64 = { class: "grid grid-cols-2 gap-5" }
const _hoisted_65 = { class: "grid grid-cols-2 gap-5 mt-5" }
const _hoisted_66 = { class: "px-4 py-3 border-b border-gray-200 dark:border-gray-700 flex items-center justify-between" }
const _hoisted_67 = { class: "max-h-[600px] overflow-y-auto" }
const _hoisted_68 = {
  key: 0,
  class: "p-4"
}
const _hoisted_69 = { class: "p-4 bg-rose-50 dark:bg-rose-900/20 border border-rose-200 dark:border-rose-700 rounded-xl" }
const _hoisted_70 = { class: "flex items-start" }
const _hoisted_71 = { class: "flex-1" }
const _hoisted_72 = { class: "text-sm text-rose-600 dark:text-rose-400 mt-1" }
const _hoisted_73 = { key: 1 }
const _hoisted_74 = { class: "rounded-b-xl overflow-hidden" }
const _hoisted_75 = { class: "px-4 py-3 bg-[#1a1d21] flex items-center space-x-3" }
const _hoisted_76 = { class: "text-gray-400 text-xs" }
const _hoisted_77 = { class: "px-4 py-4 bg-[#1a1d21]" }
const _hoisted_78 = ["innerHTML"]
const _hoisted_79 = {
  key: 0,
  class: "border-t border-gray-700"
}
const _hoisted_80 = { class: "px-4 py-2 bg-[#222529] flex items-center justify-between" }
const _hoisted_81 = { class: "text-[10px] text-gray-500" }
const _hoisted_82 = { class: "bg-white p-6 max-h-[400px] overflow-y-auto" }
const _hoisted_83 = {
  key: 0,
  class: "text-xl font-bold text-gray-900 mb-2"
}
const _hoisted_84 = { class: "text-xs text-gray-500 italic mb-4" }
const _hoisted_85 = {
  key: 1,
  class: "text-sm text-gray-700 mb-4"
}
const _hoisted_86 = { class: "w-full" }
const _hoisted_87 = { class: "w-full text-sm border-collapse" }
const _hoisted_88 = { class: "bg-[#4472C4]" }
const _hoisted_89 = {
  key: 2,
  class: "mt-3 text-center"
}
const _hoisted_90 = {
  key: 3,
  class: "text-xs text-gray-500 mt-6 pt-4 border-t border-gray-200"
}
const _hoisted_91 = { class: "px-4 py-3 flex items-center justify-between text-xs text-gray-500 dark:text-gray-400 border-t border-gray-200 dark:border-gray-700" }
const _hoisted_92 = { class: "text-violet-600 dark:text-violet-400" }
const _hoisted_93 = { class: "flex items-center space-x-3" }
const _hoisted_94 = {
  key: 0,
  class: "px-2 py-1 text-xs font-medium bg-emerald-100 dark:bg-emerald-900/30 text-emerald-700 dark:text-emerald-400 rounded-lg capitalize"
}
const _hoisted_95 = { class: "overflow-hidden" }
const _hoisted_96 = { class: "p-6 space-y-5" }
const _hoisted_97 = {
  key: 0,
  class: "flex justify-end"
}
const _hoisted_98 = {
  key: 1,
  class: "p-5 bg-emerald-50 dark:bg-emerald-900/20 border border-emerald-200 dark:border-emerald-700 rounded-xl space-y-4"
}
const _hoisted_99 = { class: "flex items-center justify-between" }
const _hoisted_100 = ["onKeydown"]
const _hoisted_101 = {
  key: 0,
  class: "text-xs text-rose-500"
}
const _hoisted_102 = {
  key: 1,
  class: "text-xs text-emerald-600 dark:text-emerald-400"
}
const _hoisted_103 = { class: "grid grid-cols-2 gap-5" }
const _hoisted_104 = { key: 0 }
const _hoisted_105 = { key: 1 }
const _hoisted_106 = { key: 2 }
const _hoisted_107 = {
  key: 3,
  class: "p-3 bg-rose-50 dark:bg-rose-900/20 border border-rose-200 dark:border-rose-700 rounded-xl"
}
const _hoisted_108 = { class: "text-sm text-rose-600 dark:text-rose-400" }
const _hoisted_109 = {
  key: 4,
  class: "p-3 bg-emerald-50 dark:bg-emerald-900/20 border border-emerald-200 dark:border-emerald-700 rounded-xl"
}
const _hoisted_110 = { class: "text-sm text-emerald-600 dark:text-emerald-400" }
const _hoisted_111 = {
  key: 0,
  class: "px-6 py-4 bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-2xl"
}
const _hoisted_112 = { class: "text-sm text-red-600 dark:text-red-400" }
const _hoisted_113 = ["disabled"]
const _hoisted_114 = ["disabled"]
const _hoisted_115 = {
  key: 0,
  class: "animate-spin h-4 w-4",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

import { ref, watch, inject, reactive, nextTick } from 'vue'
import { useTheme } from '../../../utils/useTheme'
import type {
  ReportConfig,
  ReportStatus,
  CreateReportRequest,
  UpdateReportRequest,
  ScheduleConfig,
  SourceDefinition,
  SinkDefinition,
  TransformDefinition,
  SlackSinkConfig,
  HttpSourceConfig,
  TemplateTransformConfig,
  ExecuteStageResponse
} from '../../../types/platform-report'
import { platformReportsService } from '../../../services/platform-reports'
import { toString } from 'cronstrue'
import authService from '../../../services/auth/auth'

// ============================================================================
// Feature Toggles - Flip these to enable/disable features
// ============================================================================
interface ReportFormData {
  name: string
  schedule: ScheduleConfig
  source: SourceDefinition
  transform: TransformDefinition
  sink: SinkDefinition
  status: ReportStatus
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ReportForm',
  props: {
    mode: {},
    reportData: {}
  },
  emits: ["saved", "cancel"],
  setup(__props: any, { emit: __emit }) {

const FEATURE_TOGGLES = {
  ENABLE_CURL_IMPORT: true, // Enable "Import cURL" button in HTTP Source section
  ENABLE_CURL_EXPORT: true, // Enable "Export as cURL" button in HTTP Source section
  ENABLE_SLACK_URL_IMPORT_BUTTON: false, // Enable separate "Import Slack URL" button (deprecated)
  ENABLE_SLACK_URL_AUTO_DETECT: true, // Auto-detect Slack URLs when pasted in User ID/Channel ID fields
  ENABLE_SOURCE_PREVIEW: true, // Enable "Preview" button in HTTP Source section (edit mode only)
  ENABLE_TRANSFORM_PREVIEW: true // Enable "Preview" button in Template section (edit mode only)
}

const props = __props

const emit = __emit

const theme = inject('theme', useTheme())

// Collapsible sections state
const sections = reactive({
  source: true,
  template: true,
  sink: true
})

// Cron presets
const cronPresets = [
  { label: 'Daily at 9 AM', value: '0 9 * * *' },
  { label: 'Weekdays at 9 AM', value: '0 9 * * 1-5' },
  { label: 'Every hour', value: '0 * * * *' },
  { label: 'Every 6 hours', value: '0 */6 * * *' },
  { label: 'Weekly (Mon 9 AM)', value: '0 9 * * 1' },
  { label: 'Monthly (1st at 9 AM)', value: '0 9 1 * *' }
]

// File config toggle
const fileConfigEnabled = ref(false)
const fileConfigHeaders = ref('')

// Sort configuration
const sortColumns = ref('')
const sortOrder = ref<'asc' | 'desc'>('desc')

// Headers list for dynamic key-value pairs
const headersList = ref<Array<{ key: string; value: string }>>([])

// Body JSON string
const bodyJson = ref('')
const bodyJsonError = ref<string | null>(null)

// User IDs input (for single or group DM)
const userIdsInput = ref('')

// cURL import state
const showCurlInput = ref(false)
const curlInput = ref('')
const curlError = ref<string | null>(null)
const curlInputRef = ref<HTMLTextAreaElement | null>(null)

// Slack URL import state
const showSlackUrlInput = ref(false)
const slackUrlInput = ref('')
const slackUrlError = ref<string | null>(null)
const slackUrlSuccess = ref<string | null>(null)
const slackUrlInputRef = ref<HTMLInputElement | null>(null)

// Slack field paste error/success messages
const slackFieldError = ref<string | null>(null)
const slackFieldSuccess = ref<string | null>(null)

// Loading state
const isSubmitting = ref(false)
const submitError = ref<string | null>(null)

// Preview state
const sourcePreviewLoading = ref(false)
const sourcePreviewData = ref<ExecuteStageResponse | null>(null)
const sourcePreviewError = ref<string | null>(null)
const showSourcePreview = ref(false)

const transformPreviewLoading = ref(false)
const transformPreviewData = ref<ExecuteStageResponse | null>(null)
const transformPreviewError = ref<string | null>(null)
const showTransformPreview = ref(false)

// State to remember preview open status for post-save restoration
const pendingSourcePreviewRestore = ref(false)
const pendingTransformPreviewRestore = ref(false)

// PDF preview rows expansion
const showAllPdfRows = ref(false)

// Format sink action for display
const formatSinkAction = (action: string) => {
  const actionMap: Record<string, string> = {
    sendToDM: 'DM',
    sendToChannel: 'Channel',
    sendToThread: 'Thread'
  }
  return actionMap[action] || action
}

// Form state
const getDefaultForm = (): ReportFormData => ({
  name: '',
  schedule: {
    type: 'cron',
    expression: '0 9 * * *'
  },
  source: {
    type: 'http',
    config: {
      url: '',
      method: 'GET',
      headers: {},
      timeout: 30000
    } as HttpSourceConfig
  },
  transform: {
    type: 'template',
    config: {
      template: '',
      fileConfig: {
        enabled: false,
        dataPath: 'data.value',
        headers: [],
        topN: 20
      }
    } as TemplateTransformConfig
  },
  sink: {
    type: 'slack',
    config: {
      action: 'sendToDM',
      userId: '',
      userIds: [],
      channelId: '',
      threadTs: '',
      file: {
        filename: '',
        title: '',
        beforeContent: '',
        afterContent: ''
      }
    } as SlackSinkConfig
  },
  status: 'draft'
})

const form = reactive<ReportFormData>(getDefaultForm())

// Reset form to defaults
const resetForm = () => {
  const defaults = getDefaultForm()
  form.name = defaults.name
  form.status = defaults.status
  form.schedule = defaults.schedule
  form.source = defaults.source
  form.transform = defaults.transform
  form.sink = defaults.sink
  fileConfigEnabled.value = false
  fileConfigHeaders.value = ''
  sortColumns.value = ''
  sortOrder.value = 'desc'
  headersList.value = []
  bodyJson.value = ''
  bodyJsonError.value = null
  userIdsInput.value = ''
  submitError.value = null
  // Reset import states
  showCurlInput.value = false
  curlInput.value = ''
  curlError.value = null
  showSlackUrlInput.value = false
  slackUrlInput.value = ''
  slackUrlError.value = null
  slackUrlSuccess.value = null
}

// Watch for edit mode changes
watch(
  () => props.reportData,
  (newData) => {
    if (newData) {
      form.name = newData.name || ''
      form.status = newData.status ?? 'draft'
      form.source = JSON.parse(JSON.stringify(newData.source))
      form.transform = JSON.parse(JSON.stringify(newData.transform))
      form.sink = JSON.parse(JSON.stringify(newData.sink))

      // Handle schedule
      if (newData.schedule) {
        form.schedule = JSON.parse(JSON.stringify(newData.schedule))
      } else {
        form.schedule = { type: 'manual' }
      }

      // Handle headers
      const headers = (newData.source.config as HttpSourceConfig).headers || {}
      headersList.value = Object.entries(headers).map(([key, value]) => ({ key, value }))

      // Handle body
      const body = (newData.source.config as HttpSourceConfig).body
      if (body) {
        bodyJson.value = typeof body === 'string' ? body : JSON.stringify(body, null, 2)
      } else {
        bodyJson.value = ''
      }

      // Handle file config
      const fileConfig = (newData.transform.config as TemplateTransformConfig).fileConfig
      if (fileConfig?.enabled) {
        fileConfigEnabled.value = true
        fileConfigHeaders.value = fileConfig.headers ? fileConfig.headers.join(', ') : ''
        // Handle sort config
        if (fileConfig.sort) {
          sortColumns.value = fileConfig.sort.columns ? fileConfig.sort.columns.join(', ') : ''
          sortOrder.value = fileConfig.sort.order || 'desc'
        } else {
          sortColumns.value = ''
          sortOrder.value = 'desc'
        }
        // Ensure fileConfig exists in form
        if (!form.transform.config.fileConfig) {
          form.transform.config.fileConfig = {
            enabled: true,
            dataPath: fileConfig.dataPath,
            headers: fileConfig.headers,
            topN: fileConfig.topN,
            sort: fileConfig.sort
          }
        }
      } else {
        fileConfigEnabled.value = false
        fileConfigHeaders.value = ''
        sortColumns.value = ''
        sortOrder.value = 'desc'
      }

      // Handle user IDs
      const sinkConfig = newData.sink.config as SlackSinkConfig
      if (sinkConfig.userIds && sinkConfig.userIds.length > 0) {
        userIdsInput.value = sinkConfig.userIds.join(', ')
      } else if (sinkConfig.userId) {
        userIdsInput.value = sinkConfig.userId
      } else {
        userIdsInput.value = ''
      }

      // Ensure file config exists in sink
      if (!form.sink.config.file) {
        form.sink.config.file = {
          filename: '',
          title: '',
          beforeContent: '',
          afterContent: ''
        }
      }
      if (sinkConfig.file) {
        form.sink.config.file = { ...sinkConfig.file }
      }

      // Restore preview states if they were open before save
      nextTick(() => {
        if (pendingSourcePreviewRestore.value) {
          pendingSourcePreviewRestore.value = false
          previewSourceStage()
        }
        if (pendingTransformPreviewRestore.value) {
          pendingTransformPreviewRestore.value = false
          previewTransformStage()
        }
      })
    } else if (props.mode === 'create') {
      resetForm()
    }
  },
  { immediate: true }
)

// Watch fileConfigEnabled to initialize fileConfig
watch(fileConfigEnabled, (enabled) => {
  if (enabled) {
    if (!form.transform.config.fileConfig) {
      form.transform.config.fileConfig = {
        enabled: true,
        dataPath: 'data.value',
        headers: [],
        topN: 20
      }
    } else {
      form.transform.config.fileConfig.enabled = true
    }
    // Initialize file in sink if not exists
    if (!form.sink.config.file) {
      form.sink.config.file = {
        filename: '',
        title: '',
        beforeContent: '',
        afterContent: ''
      }
    }
  } else {
    if (form.transform.config.fileConfig) {
      form.transform.config.fileConfig.enabled = false
    }
  }
})

const addHeader = () => {
  headersList.value.push({ key: '', value: '' })
}

const removeHeader = (index: number) => {
  headersList.value.splice(index, 1)
}

const handleCancel = () => {
  emit('cancel')
}

// Parse cURL command and populate form fields
const parseCurlCommand = () => {
  curlError.value = null
  const curl = curlInput.value.trim()

  if (!curl) {
    curlError.value = 'Please paste a cURL command'
    return
  }

  try {
    // Extract URL - handle both single and double quotes
    const urlMatch =
      curl.match(/curl\s+(?:-X\s+\w+\s+)?['"]?(https?:\/\/[^\s'"]+)['"]?/i) ||
      curl.match(/['"]?(https?:\/\/[^\s'"]+)['"]?/)

    if (!urlMatch) {
      curlError.value = 'Could not find a valid URL in the cURL command'
      return
    }

    const url = urlMatch[1]
    form.source.config.url = url

    // Extract method (default to GET)
    const methodMatch = curl.match(/-X\s+(\w+)/i)
    const method = methodMatch ? methodMatch[1].toUpperCase() : 'GET'
    if (['GET', 'POST', 'PUT', 'PATCH', 'DELETE'].includes(method)) {
      form.source.config.method = method as 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE'
    }

    // If there's -d or --data, it's likely a POST
    if (!methodMatch && (curl.includes('-d ') || curl.includes('--data '))) {
      form.source.config.method = 'POST'
    }

    // Extract headers
    const headerRegex = /-H\s+['"]([^'"]+)['"]/gi
    const newHeaders: Array<{ key: string; value: string }> = []
    let headerMatch

    while ((headerMatch = headerRegex.exec(curl)) !== null) {
      const headerStr = headerMatch[1]
      const colonIndex = headerStr.indexOf(':')
      if (colonIndex > 0) {
        const key = headerStr.substring(0, colonIndex).trim()
        const value = headerStr.substring(colonIndex + 1).trim()
        newHeaders.push({ key, value })
      }
    }

    if (newHeaders.length > 0) {
      headersList.value = newHeaders
    }

    // Extract body data
    const dataMatch =
      curl.match(/(?:-d|--data|--data-raw)\s+['"](.+?)['"]\s*(?:-|$)/s) ||
      curl.match(/(?:-d|--data|--data-raw)\s+'([^']+)'/s) ||
      curl.match(/(?:-d|--data|--data-raw)\s+"([^"]+)"/s)

    if (dataMatch) {
      const bodyData = dataMatch[1]
      try {
        // Try to parse and format as JSON
        const parsed = JSON.parse(bodyData)
        bodyJson.value = JSON.stringify(parsed, null, 2)
      } catch {
        // If not valid JSON, use as-is
        bodyJson.value = bodyData
      }
    }

    // Close the input and show success
    showCurlInput.value = false
    curlInput.value = ''
  } catch {
    curlError.value = 'Failed to parse cURL command. Please check the format.'
  }
}

// Export current HTTP source config as cURL command
const exportAsCurl = () => {
  const config = form.source.config
  const parts: string[] = ['curl']

  // Add method (skip for GET as it's default)
  if (config.method !== 'GET') {
    parts.push(`-X ${config.method}`)
  }

  // Add URL
  parts.push(`'${config.url}'`)

  // Add headers from headersList
  for (const header of headersList.value) {
    if (header.key && header.value) {
      parts.push(`-H '${header.key}: ${header.value}'`)
    }
  }

  // Add body for POST/PUT/PATCH
  if (['POST', 'PUT', 'PATCH'].includes(config.method) && bodyJson.value.trim()) {
    // Escape single quotes in the body
    const escapedBody = bodyJson.value.replace(/'/g, "'\\''")
    parts.push(`-d '${escapedBody}'`)
  }

  const curlCommand = parts.join(' \\\n  ')

  // Copy to clipboard
  navigator.clipboard
    .writeText(curlCommand)
    .then(() => {
      // Show a brief success message (could use a toast here)
      alert('cURL command copied to clipboard!')
    })
    .catch(() => {
      // Fallback: show the command in a prompt
      prompt('Copy this cURL command:', curlCommand)
    })
}

// Parse Slack URL and populate sink config
const parseSlackUrl = () => {
  slackUrlError.value = null
  slackUrlSuccess.value = null
  const url = slackUrlInput.value.trim()

  if (!url) {
    slackUrlError.value = 'Please paste a Slack URL'
    return
  }

  try {
    // Slack URL patterns:
    // User Profile: https://gohighlevel.enterprise.slack.com/team/U07AHULLYEM
    // Channel: https://gohighlevel.enterprise.slack.com/archives/C097UPY34QJ
    // Thread: https://gohighlevel.slack.com/archives/C07B7JRBE57/p1767606812836559
    // DM Conversation (invalid): https://gohighlevel.enterprise.slack.com/archives/D07AHULNTBK

    // Check for user profile URL first: /team/U...
    const teamMatch = url.match(/\/team\/([A-Z0-9]+)/i)
    if (teamMatch) {
      const userId = teamMatch[1]
      const firstChar = userId.charAt(0).toUpperCase()

      if (firstChar === 'U') {
        // Valid user ID from profile URL
        form.sink.config.action = 'sendToDM'
        userIdsInput.value = userId
        form.sink.config.channelId = ''
        form.sink.config.threadTs = ''
        slackUrlSuccess.value = `User ID detected: ${userId}`

        // Close the input after a short delay
        setTimeout(() => {
          showSlackUrlInput.value = false
          slackUrlInput.value = ''
          slackUrlSuccess.value = null
        }, 1500)
        return
      } else {
        slackUrlError.value = `Invalid team URL: "${userId}" doesn't look like a User ID (should start with U).`
        return
      }
    }

    // Extract the archive ID (channel/DM ID)
    const archiveMatch = url.match(/\/archives\/([A-Z0-9]+)/i)

    if (!archiveMatch) {
      slackUrlError.value =
        'Could not find a valid Slack channel/user ID in the URL. Supported: /team/U..., /archives/C..., /archives/.../p...'
      return
    }

    const id = archiveMatch[1]

    // Check for thread timestamp (format: /pXXXXXXXXXXXXXXXX)
    const threadMatch = url.match(/\/p(\d+)$/)

    // Determine type based on ID prefix:
    // C = Channel, G = Group/Private Channel, U = User (from /team/ URL)
    const firstChar = id.charAt(0).toUpperCase()

    if (threadMatch) {
      // It's a thread - extract timestamp
      // Slack thread ts format: first 10 digits are seconds, rest are microseconds
      // URL format p1767606812836559 -> 1767606812.836559
      const rawTs = threadMatch[1]
      const threadTs =
        rawTs.length > 10 ? `${rawTs.substring(0, 10)}.${rawTs.substring(10)}` : rawTs

      form.sink.config.action = 'sendToThread'
      form.sink.config.channelId = id
      form.sink.config.threadTs = threadTs
      slackUrlSuccess.value = `Thread detected: Channel ${id}, Thread ${threadTs}`
    } else if (firstChar === 'C' || firstChar === 'G') {
      // It's a channel (C) or private channel/group (G)
      form.sink.config.action = 'sendToChannel'
      form.sink.config.channelId = id
      form.sink.config.threadTs = ''
      slackUrlSuccess.value = `Channel detected: ${id}`
    } else if (firstChar === 'D') {
      // D = DM conversation ID - this is NOT a user ID
      slackUrlError.value = `Invalid URL: "${id}" is a DM conversation ID, not a User ID. For DMs, paste the user's profile URL (slack.com/team/U...) or enter the User ID directly.`
      return
    } else {
      // Unknown type
      slackUrlError.value = `Unknown Slack ID type: ${id}. Expected Channel (C...), Thread, or User profile URL (/team/U...).`
      return
    }

    // Close the input after a short delay to show success message
    setTimeout(() => {
      showSlackUrlInput.value = false
      slackUrlInput.value = ''
      slackUrlSuccess.value = null
    }, 1500)
  } catch {
    slackUrlError.value = 'Failed to parse Slack URL. Please check the format.'
  }
}

// Clear Slack field messages when user types
const clearSlackFieldMessages = () => {
  slackFieldError.value = null
  slackFieldSuccess.value = null
}

// Auto-detect and parse Slack URL on paste in User ID/Channel ID fields
const onSlackFieldPaste = (
  event: ClipboardEvent,
  fieldType: 'userId' | 'channelId' | 'threadTs'
) => {
  // Clear previous messages
  slackFieldError.value = null
  slackFieldSuccess.value = null

  if (!FEATURE_TOGGLES.ENABLE_SLACK_URL_AUTO_DETECT) return

  const pastedText = event.clipboardData?.getData('text')?.trim()
  if (!pastedText) return

  // Check if it looks like a Slack URL (supports /archives/ and /team/ URLs)
  const isSlackUrl =
    pastedText.includes('slack.com/archives/') || pastedText.includes('slack.com/team/')
  if (!isSlackUrl) return

  // Prevent default paste behavior - we'll handle it
  event.preventDefault()

  try {
    // Check for user profile URL first: /team/U...
    const teamMatch = pastedText.match(/\/team\/([A-Z0-9]+)/i)
    if (teamMatch) {
      const userId = teamMatch[1]
      const firstChar = userId.charAt(0).toUpperCase()

      if (firstChar === 'U') {
        // Valid user ID from profile URL
        form.sink.config.action = 'sendToDM'
        userIdsInput.value = userId
        form.sink.config.channelId = ''
        form.sink.config.threadTs = ''
        slackFieldSuccess.value = `User ID detected: ${userId}`
        return
      } else {
        slackFieldError.value = `Invalid team URL: "${userId}" doesn't look like a User ID (should start with U).`
        return
      }
    }

    // Extract the archive ID (channel/DM ID)
    const archiveMatch = pastedText.match(/\/archives\/([A-Z0-9]+)/i)
    if (!archiveMatch) {
      // Not a valid Slack URL, let the normal paste happen
      return
    }

    const id = archiveMatch[1]

    // Check for thread timestamp (format: /pXXXXXXXXXXXXXXXX)
    const threadMatch = pastedText.match(/\/p(\d+)$/)

    // Determine type based on ID prefix
    const firstChar = id.charAt(0).toUpperCase()

    if (threadMatch) {
      // It's a thread URL - extract channel and timestamp
      const rawTs = threadMatch[1]
      const threadTs =
        rawTs.length > 10 ? `${rawTs.substring(0, 10)}.${rawTs.substring(10)}` : rawTs

      form.sink.config.action = 'sendToThread'
      form.sink.config.channelId = id
      form.sink.config.threadTs = threadTs
      slackFieldSuccess.value = `Thread detected: Channel ${id}, Thread ${threadTs}`
    } else if (firstChar === 'C' || firstChar === 'G') {
      // It's a channel (C) or private channel/group (G)
      form.sink.config.action = 'sendToChannel'
      form.sink.config.channelId = id
      form.sink.config.threadTs = ''
      slackFieldSuccess.value = `Channel detected: ${id}`
    } else if (firstChar === 'D') {
      // D = DM conversation ID - this is NOT a user ID
      slackFieldError.value = `Invalid URL: "${id}" is a DM conversation ID, not a User ID. For DMs, paste the user's profile URL (slack.com/team/U...) or enter the User ID directly.`
      return
    } else {
      // Unknown type - show error
      slackFieldError.value = `Unknown Slack ID type: ${id}. Expected Channel (C...), Thread, or User ID (U...).`
      return
    }
  } catch {
    // If parsing fails, just paste the original text
    if (fieldType === 'userId') {
      userIdsInput.value = pastedText
    } else if (fieldType === 'channelId') {
      form.sink.config.channelId = pastedText
    } else if (fieldType === 'threadTs') {
      form.sink.config.threadTs = pastedText
    }
  }
}

// Helper to safely get fileData from preview response
const getFileData = (data: Record<string, unknown> | undefined): unknown => {
  if (!data) return null
  return data.fileData || null
}

// Helper to get file data row count
const getFileDataRowCount = (data: Record<string, unknown> | undefined): number => {
  const fileData = getFileData(data) as { rows?: unknown[] } | null
  return fileData?.rows?.length || 0
}

// Helper to get file data headers
const getFileDataHeaders = (data: Record<string, unknown> | undefined): string[] => {
  const fileData = getFileData(data) as { headers?: string[] } | null
  return fileData?.headers || []
}

// Helper to get file data rows (limited)
const getFileDataRows = (
  data: Record<string, unknown> | undefined,
  limit: number
): Record<string, unknown>[] => {
  const fileData = getFileData(data) as { rows?: Record<string, unknown>[] } | null
  const rows = fileData?.rows || []
  return rows.slice(0, limit)
}

// Helper to get sink file config for PDF preview
const getSinkFileConfig = () => {
  return form.sink.config.file || { title: '', beforeContent: '', afterContent: '', filename: '' }
}

// Format Slack message markdown to HTML for preview
const formatSlackMessage = (message: string): string => {
  if (!message) return ''

  const html = message
    // Escape HTML first
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    // Bold: *text* -> <strong>text</strong>
    .replace(/\*([^*\n]+)\*/g, '<strong>$1</strong>')
    // Italic: _text_ -> <em>text</em>
    .replace(/_([^_\n]+)_/g, '<em class="text-gray-400">$1</em>')
    // Strikethrough: ~text~ -> <del>text</del>
    .replace(/~([^~\n]+)~/g, '<del>$1</del>')
    // Code: `text` -> <code>text</code>
    .replace(
      /`([^`\n]+)`/g,
      '<code class="px-1 py-0.5 bg-gray-700 rounded text-pink-400 text-sm">$1</code>'
    )
    // Links: <url|text> -> <a>text</a>
    .replace(
      /&lt;([^|>]+)\|([^>]+)&gt;/g,
      '<a href="$1" class="text-blue-400 hover:underline" target="_blank">$2</a>'
    )
    // Plain links: <url> -> <a>url</a>
    .replace(
      /&lt;(https?:\/\/[^>]+)&gt;/g,
      '<a href="$1" class="text-blue-400 hover:underline" target="_blank">$1</a>'
    )
    // Newlines to <br>
    .replace(/\n/g, '<br>')

  return html
}

// Parse cron expression to human-readable format using cronstrue
const parseCronExpression = (expression: string): string => {
  if (!expression || expression.trim() === '') {
    return 'Enter a cron expression to see the schedule'
  }

  try {
    return toString(expression, {
      use24HourTimeFormat: false,
      throwExceptionOnParseError: false
    })
  } catch {
    return 'Invalid cron expression format'
  }
}

// Get IST equivalent time for cron expression
const getISTTime = (expression: string): string | null => {
  if (!expression || expression.trim() === '') {
    return null
  }

  try {
    const parts = expression.trim().split(/\s+/)
    if (parts.length !== 5) {
      return null
    }

    const [minute, hour] = parts

    // Only show IST conversion if we have specific hour and minute (not wildcards)
    if (hour === '*' || minute === '*') {
      return null
    }

    const utcHour = parseInt(hour, 10)
    const utcMinute = parseInt(minute, 10)

    if (isNaN(utcHour) || isNaN(utcMinute)) {
      return null
    }

    // IST is UTC + 5:30
    let istHour = utcHour + 5
    let istMinute = utcMinute + 30

    if (istMinute >= 60) {
      istMinute -= 60
      istHour += 1
    }

    if (istHour >= 24) {
      istHour -= 24
    }

    const period = istHour >= 12 ? 'PM' : 'AM'
    const displayHour = istHour > 12 ? istHour - 12 : istHour === 0 ? 12 : istHour
    const displayMinute = istMinute.toString().padStart(2, '0')

    return `At ${displayHour}:${displayMinute} ${period} IST daily`
  } catch {
    return null
  }
}

// Format epoch timestamp (milliseconds) to IST
const formatEpochToIST = (epochMs?: number | string) => {
  if (!epochMs) return '-'
  // Handle both number and string (for backward compatibility)
  const timestamp = typeof epochMs === 'string' ? parseInt(epochMs, 10) : epochMs
  if (isNaN(timestamp)) return '-'
  const date = new Date(timestamp)
  return `${date.toLocaleString('en-IN', {
    timeZone: 'Asia/Kolkata',
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: true
  })} IST`
}

// Preview functions
const previewSourceStage = async () => {
  if (!props.reportData?.id) {
    sourcePreviewError.value = 'Please save the report first to preview'
    return
  }

  sourcePreviewLoading.value = true
  sourcePreviewError.value = null
  sourcePreviewData.value = null

  try {
    const response = await platformReportsService.executeReportStage(props.reportData.id, 'source')

    // Ensure the response has the expected structure
    // Handle both direct response and wrapped response scenarios
    const normalizedResponse: ExecuteStageResponse = {
      code: response.code ?? 200,
      success: response.success ?? response.code === 200,
      stage: response.stage ?? 'source',
      data: response.data ?? response,
      message: response.message ?? '',
      traceId: response.traceId ?? ''
    }

    sourcePreviewData.value = normalizedResponse
    showSourcePreview.value = true
  } catch (error) {
    sourcePreviewError.value = error instanceof Error ? error.message : 'Failed to preview source'
  } finally {
    sourcePreviewLoading.value = false
  }
}

const previewTransformStage = async () => {
  if (!props.reportData?.id) {
    transformPreviewError.value = 'Please save the report first to preview'
    return
  }

  transformPreviewLoading.value = true
  transformPreviewError.value = null
  transformPreviewData.value = null
  showAllPdfRows.value = false // Reset row expansion

  try {
    const response = await platformReportsService.executeReportStage(
      props.reportData.id,
      'transform'
    )

    // Ensure the response has the expected structure
    // Handle both direct response and wrapped response scenarios
    const normalizedResponse: ExecuteStageResponse = {
      code: response.code ?? 200,
      success: response.success ?? response.code === 200,
      stage: response.stage ?? 'transform',
      data: response.data ?? response,
      message: response.message ?? '',
      traceId: response.traceId ?? ''
    }

    transformPreviewData.value = normalizedResponse
    showTransformPreview.value = true
  } catch (error) {
    transformPreviewError.value =
      error instanceof Error ? error.message : 'Failed to preview transform'
  } finally {
    transformPreviewLoading.value = false
  }
}

const handleSubmit = async () => {
  isSubmitting.value = true
  submitError.value = null
  bodyJsonError.value = null

  try {
    // Build headers from list
    const headers: Record<string, string> = {}
    headersList.value.forEach((h) => {
      if (h.key.trim()) {
        headers[h.key.trim()] = h.value
      }
    })

    // Parse body JSON if present
    let body: Record<string, unknown> | undefined
    if (bodyJson.value.trim() && ['POST', 'PUT', 'PATCH'].includes(form.source.config.method)) {
      try {
        body = JSON.parse(bodyJson.value)
      } catch {
        bodyJsonError.value = 'Invalid JSON format'
        isSubmitting.value = false
        return
      }
    }

    // Build file config headers
    const fileHeaders = fileConfigHeaders.value
      .split(',')
      .map((h) => h.trim())
      .filter((h) => h.length > 0)

    // Parse user IDs
    const userIdsParsed = userIdsInput.value
      .split(',')
      .map((id) => id.trim())
      .filter((id) => id.length > 0)

    // Build schedule config
    const scheduleConfig: ScheduleConfig = {
      type: form.schedule.type
    }
    if (form.schedule.type === 'cron' && form.schedule.expression) {
      scheduleConfig.expression = form.schedule.expression
    }

    // Build source config
    const sourceConfig: HttpSourceConfig = {
      url: form.source.config.url,
      method: form.source.config.method,
      timeout: form.source.config.timeout || 30000
    }
    if (Object.keys(headers).length > 0) {
      sourceConfig.headers = headers
    }
    if (body) {
      sourceConfig.body = body
    }

    // Build transform config
    const transformConfig: TemplateTransformConfig = {
      template: form.transform.config.template
    }
    if (fileConfigEnabled.value && form.transform.config.fileConfig) {
      // Parse sort columns
      const sortColumnsParsed = sortColumns.value
        .split(',')
        .map((c) => c.trim())
        .filter((c) => c.length > 0)

      transformConfig.fileConfig = {
        enabled: true,
        dataPath: form.transform.config.fileConfig.dataPath,
        headers: fileHeaders.length > 0 ? fileHeaders : undefined,
        topN: form.transform.config.fileConfig.topN
      }

      // Add sort config only if columns are specified
      if (sortColumnsParsed.length > 0) {
        transformConfig.fileConfig.sort = {
          columns: sortColumnsParsed,
          order: sortOrder.value
        }
      }
    }

    // Build sink config
    const sinkConfig: SlackSinkConfig = {
      action: form.sink.config.action
    }

    if (form.sink.config.action === 'sendToDM') {
      if (userIdsParsed.length === 1) {
        sinkConfig.userId = userIdsParsed[0]
      } else if (userIdsParsed.length > 1) {
        sinkConfig.userIds = userIdsParsed
      }
    } else {
      sinkConfig.channelId = form.sink.config.channelId
    }

    if (form.sink.config.action === 'sendToThread') {
      sinkConfig.threadTs = form.sink.config.threadTs
    }

    // Add file config if enabled
    if (fileConfigEnabled.value && form.sink.config.file?.filename) {
      sinkConfig.file = {
        filename: form.sink.config.file.filename,
        title: form.sink.config.file.title,
        beforeContent: form.sink.config.file.beforeContent,
        afterContent: form.sink.config.file.afterContent
      }
    }

    if (props.mode === 'edit' && props.reportData) {
      // Update existing report
      // Get current user email
      const user = authService.getUser()
      const userEmail = user?.email || ''

      const updateData: UpdateReportRequest = {
        name: form.name || undefined,
        schedule: scheduleConfig,
        status: form.status,
        source: {
          type: 'http',
          config: sourceConfig
        },
        transform: {
          type: 'template',
          config: transformConfig
        },
        sink: {
          type: 'slack',
          config: sinkConfig
        },
        meta: {
          updatedBy: userEmail
        }
      }

      // Remember preview states before save triggers data refresh
      pendingSourcePreviewRestore.value = showSourcePreview.value
      pendingTransformPreviewRestore.value = showTransformPreview.value

      await platformReportsService.updateReport(props.reportData.id, updateData)
      emit('saved')
    } else {
      // Create new report
      // Get current user email
      const user = authService.getUser()
      const userEmail = user?.email || ''

      const createData: CreateReportRequest = {
        name: form.name || undefined,
        schedule: scheduleConfig,
        status: form.status,
        source: {
          type: 'http',
          config: sourceConfig
        },
        transform: {
          type: 'template',
          config: transformConfig
        },
        sink: {
          type: 'slack',
          config: sinkConfig
        },
        meta: {
          createdBy: userEmail
        }
      }

      await platformReportsService.createReport(createData)
      emit('saved')
    }
  } catch (err) {
    submitError.value =
      err instanceof Error ? err.message : 'An error occurred while saving the report'
  } finally {
    isSubmitting.value = false
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass([
        _unref(theme).isDark.value ? 'bg-gray-800' : 'bg-white',
        'rounded-2xl overflow-hidden shadow-lg-custom'
      ]),
      style: {"box-shadow":"var(--shadow-lg)"}
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", null, [
          _cache[37] || (_cache[37] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2" }, " Report Name ", -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.name) = $event)),
            type: "text",
            class: "w-full px-4 py-3 border rounded-xl text-sm focus:outline-none focus:ring-2 bg-white dark:bg-gray-700 border-gray-300 dark:border-gray-600 text-gray-900 dark:text-white focus:ring-emerald-500 focus:border-emerald-500 transition-all",
            placeholder: "e.g., Daily Error Report"
          }, null, 512), [
            [_vModelText, form.name]
          ])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _cache[38] || (_cache[38] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-3" }, " Report Status ", -1)),
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['draft', 'active', 'inactive'], (status) => {
              return _createElementVNode("button", {
                key: status,
                type: "button",
                class: _normalizeClass([
                form.status === status
                  ? status === 'active'
                    ? 'bg-emerald-500 text-white border-emerald-500'
                    : status === 'draft'
                      ? 'bg-amber-500 text-white border-amber-500'
                      : 'bg-gray-500 text-white border-gray-500'
                  : 'bg-white dark:bg-gray-700 text-gray-700 dark:text-gray-300 border-gray-300 dark:border-gray-600 hover:bg-gray-50 dark:hover:bg-gray-600',
                'px-5 py-2.5 text-sm font-medium border rounded-xl transition-all duration-200 capitalize'
              ]),
                onClick: ($event: any) => (form.status = status as ReportStatus)
              }, _toDisplayString(status), 11, _hoisted_5)
            }), 64))
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _cache[46] || (_cache[46] = _createStaticVNode("<div class=\"flex items-center\"><div class=\"p-2 bg-blue-100 dark:bg-blue-900/30 rounded-lg mr-3\"><svg class=\"w-5 h-5 text-blue-500\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z\"></path></svg></div><h4 class=\"text-base font-semibold text-gray-900 dark:text-white\">Schedule</h4></div>", 1)),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", null, [
              _cache[40] || (_cache[40] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2" }, " Schedule Type ", -1)),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.schedule.type) = $event)),
                class: "w-full px-4 py-3 border rounded-xl text-sm focus:outline-none focus:ring-2 bg-white dark:bg-gray-700 border-gray-300 dark:border-gray-600 text-gray-900 dark:text-white focus:ring-emerald-500 focus:border-emerald-500 transition-all"
              }, _cache[39] || (_cache[39] = [
                _createElementVNode("option", { value: "cron" }, "Cron", -1),
                _createElementVNode("option", { value: "manual" }, "Manual", -1)
              ]), 512), [
                [_vModelSelect, form.schedule.type]
              ])
            ]),
            (form.schedule.type === 'cron')
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _cache[41] || (_cache[41] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2" }, " Cron Expression ", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.schedule.expression) = $event)),
                    type: "text",
                    class: "w-full px-4 py-3 border rounded-xl text-sm font-mono focus:outline-none focus:ring-2 bg-white dark:bg-gray-700 border-gray-300 dark:border-gray-600 text-gray-900 dark:text-white focus:ring-emerald-500 focus:border-emerald-500 transition-all",
                    placeholder: "e.g., 0 9 * * 1-5"
                  }, null, 512), [
                    [_vModelText, form.schedule.expression]
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          (form.schedule.type === 'cron')
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(cronPresets, (preset) => {
                  return _createElementVNode("button", {
                    key: preset.value,
                    type: "button",
                    class: _normalizeClass([
                form.schedule.expression === preset.value
                  ? 'bg-blue-100 dark:bg-blue-900/30 text-blue-700 dark:text-blue-400 border-blue-300 dark:border-blue-700'
                  : 'bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-400 border-gray-200 dark:border-gray-600',
                'px-4 py-1.5 text-xs font-medium border rounded-full transition-all duration-200 hover:bg-blue-50 dark:hover:bg-blue-900/20'
              ]),
                    onClick: ($event: any) => (form.schedule.expression = preset.value)
                  }, _toDisplayString(preset.label), 11, _hoisted_10)
                }), 64))
              ]))
            : _createCommentVNode("", true),
          (form.schedule.type === 'cron' && form.schedule.expression)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _cache[45] || (_cache[45] = _createElementVNode("svg", {
                    class: "w-5 h-5 text-blue-500 mt-0.5 mr-3 flex-shrink-0",
                    fill: "none",
                    stroke: "currentColor",
                    viewBox: "0 0 24 24"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                    })
                  ], -1)),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", null, [
                      _cache[42] || (_cache[42] = _createElementVNode("p", { class: "text-xs font-medium text-blue-700 dark:text-blue-300 mb-0.5" }, " Human readable: ", -1)),
                      _createElementVNode("p", _hoisted_14, _toDisplayString(parseCronExpression(form.schedule.expression)), 1)
                    ]),
                    (getISTTime(form.schedule.expression))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                          _cache[43] || (_cache[43] = _createElementVNode("p", { class: "text-xs font-medium text-blue-700 dark:text-blue-300 mb-0.5" }, " IST Equivalent: ", -1)),
                          _createElementVNode("p", _hoisted_16, _toDisplayString(getISTTime(form.schedule.expression)), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.mode === 'edit' && props.reportData?.meta?.nextRun)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                          _cache[44] || (_cache[44] = _createElementVNode("p", { class: "text-xs font-medium text-blue-700 dark:text-blue-300 mb-0.5" }, " Next Run: ", -1)),
                          _createElementVNode("p", _hoisted_18, _toDisplayString(formatEpochToIST(props.reportData.meta.nextRun)), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ], 2),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("div", {
        class: _normalizeClass([
          _unref(theme).isDark.value ? 'bg-gray-800' : 'bg-white',
          'rounded-2xl overflow-hidden shadow-lg-custom flex-1 transition-all duration-300',
          showSourcePreview.value ? 'max-w-[60%]' : 'max-w-full'
        ]),
        style: {"box-shadow":"var(--shadow-lg)"}
      }, [
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass(["w-full px-6 py-4 flex items-center justify-between border-b transition-colors", [
            _unref(theme).isDark.value
              ? 'border-gray-700 hover:bg-gray-700/50'
              : 'border-gray-100 hover:bg-gray-50'
          ]]),
          onClick: _cache[3] || (_cache[3] = ($event: any) => (sections.source = !sections.source))
        }, [
          _cache[51] || (_cache[51] = _createStaticVNode("<div class=\"flex items-center\"><div class=\"p-2.5 bg-blue-100 dark:bg-blue-900/30 rounded-xl mr-4\"><svg class=\"w-6 h-6 text-blue-500\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9\"></path></svg></div><div class=\"text-left\"><h3 class=\"text-lg font-semibold text-gray-900 dark:text-white\">Source</h3><p class=\"text-sm text-gray-500 dark:text-gray-400\"> HTTP API endpoint configuration </p></div></div>", 1)),
          _createElementVNode("div", _hoisted_20, [
            (form.source.config.url)
              ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(form.source.config.method) + " " + _toDisplayString(form.source.config.url), 1))
              : _createCommentVNode("", true),
            (
                FEATURE_TOGGLES.ENABLE_SOURCE_PREVIEW && _ctx.mode === 'edit' && props.reportData?.id
              )
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  type: "button",
                  class: "flex items-center space-x-1.5 px-3 py-1.5 text-xs font-medium text-blue-600 dark:text-blue-400 bg-blue-50 dark:bg-blue-900/20 hover:bg-blue-100 dark:hover:bg-blue-900/40 border border-blue-200 dark:border-blue-700 rounded-lg transition-all duration-200",
                  disabled: sourcePreviewLoading.value,
                  onClick: _withModifiers(previewSourceStage, ["stop"])
                }, [
                  (sourcePreviewLoading.value)
                    ? (_openBlock(), _createElementBlock("svg", _hoisted_23, _cache[47] || (_cache[47] = [
                        _createElementVNode("circle", {
                          class: "opacity-25",
                          cx: "12",
                          cy: "12",
                          r: "10",
                          stroke: "currentColor",
                          "stroke-width": "4"
                        }, null, -1),
                        _createElementVNode("path", {
                          class: "opacity-75",
                          fill: "currentColor",
                          d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                        }, null, -1)
                      ])))
                    : (_openBlock(), _createElementBlock("svg", _hoisted_24, _cache[48] || (_cache[48] = [
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2",
                          d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                        }, null, -1),
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2",
                          d: "M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                        }, null, -1)
                      ]))),
                  _cache[49] || (_cache[49] = _createElementVNode("span", null, "Preview", -1))
                ], 8, _hoisted_22))
              : _createCommentVNode("", true),
            (_openBlock(), _createElementBlock("svg", {
              class: _normalizeClass([
                'w-5 h-5 text-gray-400 transition-transform duration-200',
                sections.source ? 'rotate-180' : ''
              ]),
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, _cache[50] || (_cache[50] = [
              _createElementVNode("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M19 9l-7 7-7-7"
              }, null, -1)
            ]), 2))
          ])
        ], 2),
        _createVNode(_Transition, {
          "enter-active-class": "transition-all duration-300 ease-out",
          "enter-from-class": "opacity-0 max-h-0",
          "enter-to-class": "opacity-100 max-h-[2000px]",
          "leave-active-class": "transition-all duration-200 ease-in",
          "leave-from-class": "opacity-100 max-h-[2000px]",
          "leave-to-class": "opacity-0 max-h-0"
        }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                (FEATURE_TOGGLES.ENABLE_CURL_IMPORT || FEATURE_TOGGLES.ENABLE_CURL_EXPORT)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                      (FEATURE_TOGGLES.ENABLE_CURL_EXPORT && !showCurlInput.value)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            class: "flex items-center space-x-2 px-4 py-2 text-sm font-medium text-violet-600 dark:text-violet-400 bg-violet-50 dark:bg-violet-900/20 hover:bg-violet-100 dark:hover:bg-violet-900/40 border border-violet-200 dark:border-violet-700 rounded-xl transition-all duration-200",
                            onClick: exportAsCurl
                          }, _cache[52] || (_cache[52] = [
                            _createElementVNode("svg", {
                              class: "w-4 h-4",
                              fill: "none",
                              stroke: "currentColor",
                              viewBox: "0 0 24 24"
                            }, [
                              _createElementVNode("path", {
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                "stroke-width": "2",
                                d: "M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                              })
                            ], -1),
                            _createElementVNode("span", null, "Export as cURL", -1)
                          ])))
                        : _createCommentVNode("", true),
                      (FEATURE_TOGGLES.ENABLE_CURL_IMPORT && !showCurlInput.value)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            type: "button",
                            class: "flex items-center space-x-2 px-4 py-2 text-sm font-medium text-blue-600 dark:text-blue-400 bg-blue-50 dark:bg-blue-900/20 hover:bg-blue-100 dark:hover:bg-blue-900/40 border border-blue-200 dark:border-blue-700 rounded-xl transition-all duration-200",
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (showCurlInput.value = true))
                          }, _cache[53] || (_cache[53] = [
                            _createElementVNode("svg", {
                              class: "w-4 h-4",
                              fill: "none",
                              stroke: "currentColor",
                              viewBox: "0 0 24 24"
                            }, [
                              _createElementVNode("path", {
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                "stroke-width": "2",
                                d: "M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12"
                              })
                            ], -1),
                            _createElementVNode("span", null, "Import cURL", -1)
                          ])))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (showCurlInput.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                      _createElementVNode("div", _hoisted_29, [
                        _cache[55] || (_cache[55] = _createElementVNode("label", { class: "text-sm font-medium text-blue-700 dark:text-blue-300" }, " Paste cURL command ", -1)),
                        _createElementVNode("button", {
                          type: "button",
                          class: "p-1.5 text-blue-500 hover:text-blue-700 dark:hover:text-blue-300 hover:bg-blue-100 dark:hover:bg-blue-800/30 rounded-lg transition-colors",
                          onClick: _cache[5] || (_cache[5] = () => {
                      showCurlInput.value = false
                      curlInput.value = ''
                      curlError.value = null
                    })
                        }, _cache[54] || (_cache[54] = [
                          _createElementVNode("svg", {
                            class: "w-4 h-4",
                            fill: "none",
                            stroke: "currentColor",
                            viewBox: "0 0 24 24"
                          }, [
                            _createElementVNode("path", {
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              "stroke-width": "2",
                              d: "M6 18L18 6M6 6l12 12"
                            })
                          ], -1)
                        ]))
                      ]),
                      _withDirectives(_createElementVNode("textarea", {
                        ref_key: "curlInputRef",
                        ref: curlInputRef,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((curlInput).value = $event)),
                        rows: "4",
                        class: "w-full px-4 py-3 border rounded-xl text-sm font-mono focus:outline-none focus:ring-2 bg-white dark:bg-gray-700 border-blue-300 dark:border-blue-600 text-gray-900 dark:text-white focus:ring-blue-500 focus:border-blue-500",
                        placeholder: "curl -X POST 'https://api.example.com/v1/data' -H 'Authorization: Bearer token' -H 'Content-Type: application/json' -d '{\"key\": \"value\"}'",
                        onKeydown: _withKeys(_withModifiers(parseCurlCommand, ["prevent"]), ["enter"])
                      }, null, 40, _hoisted_30), [
                        [_vModelText, curlInput.value]
                      ]),
                      (curlError.value)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_31, _toDisplayString(curlError.value), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", { class: "flex items-center justify-between" }, [
                        _cache[56] || (_cache[56] = _createElementVNode("p", { class: "text-xs text-blue-600 dark:text-blue-400" }, "Press Enter to import", -1)),
                        _createElementVNode("button", {
                          type: "button",
                          class: "px-4 py-2 text-sm font-medium text-white bg-blue-500 hover:bg-blue-600 rounded-xl transition-colors",
                          onClick: parseCurlCommand
                        }, " Import ")
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("div", null, [
                    _cache[58] || (_cache[58] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2" }, [
                      _createTextVNode(" HTTP Method "),
                      _createElementVNode("span", { class: "text-rose-500" }, "*")
                    ], -1)),
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((form.source.config.method) = $event)),
                      class: "w-full px-4 py-3 border rounded-xl text-sm focus:outline-none focus:ring-2 bg-white dark:bg-gray-700 border-gray-300 dark:border-gray-600 text-gray-900 dark:text-white focus:ring-emerald-500 focus:border-emerald-500 transition-all"
                    }, _cache[57] || (_cache[57] = [
                      _createElementVNode("option", { value: "GET" }, "GET", -1),
                      _createElementVNode("option", { value: "POST" }, "POST", -1),
                      _createElementVNode("option", { value: "PUT" }, "PUT", -1),
                      _createElementVNode("option", { value: "PATCH" }, "PATCH", -1),
                      _createElementVNode("option", { value: "DELETE" }, "DELETE", -1)
                    ]), 512), [
                      [_vModelSelect, form.source.config.method]
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _cache[59] || (_cache[59] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2" }, " Timeout (ms) ", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((form.source.config.timeout) = $event)),
                      type: "number",
                      min: "1000",
                      max: "300000",
                      step: "1000",
                      class: "w-full px-4 py-3 border rounded-xl text-sm focus:outline-none focus:ring-2 bg-white dark:bg-gray-700 border-gray-300 dark:border-gray-600 text-gray-900 dark:text-white focus:ring-emerald-500 focus:border-emerald-500 transition-all",
                      placeholder: "30000"
                    }, null, 512), [
                      [
                        _vModelText,
                        form.source.config.timeout,
                        void 0,
                        { number: true }
                      ]
                    ])
                  ])
                ]),
                _createElementVNode("div", null, [
                  _cache[60] || (_cache[60] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2" }, [
                    _createTextVNode(" URL "),
                    _createElementVNode("span", { class: "text-rose-500" }, "*")
                  ], -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((form.source.config.url) = $event)),
                    type: "text",
                    required: "",
                    class: "w-full px-4 py-3 border rounded-xl text-sm font-mono focus:outline-none focus:ring-2 bg-white dark:bg-gray-700 border-gray-300 dark:border-gray-600 text-gray-900 dark:text-white focus:ring-emerald-500 focus:border-emerald-500 transition-all",
                    placeholder: "https://api.example.com/v1/data"
                  }, null, 512), [
                    [_vModelText, form.source.config.url]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("div", { class: "flex items-center justify-between mb-2" }, [
                    _cache[62] || (_cache[62] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 dark:text-gray-300" }, " Headers ", -1)),
                    _createElementVNode("button", {
                      type: "button",
                      class: "flex items-center space-x-1 text-sm text-emerald-600 dark:text-emerald-400 hover:text-emerald-700 font-medium transition-colors",
                      onClick: addHeader
                    }, _cache[61] || (_cache[61] = [
                      _createElementVNode("svg", {
                        class: "w-4 h-4",
                        fill: "none",
                        stroke: "currentColor",
                        viewBox: "0 0 24 24"
                      }, [
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2",
                          d: "M12 6v6m0 0v6m0-6h6m-6 0H6"
                        })
                      ], -1),
                      _createElementVNode("span", null, "Add Header", -1)
                    ]))
                  ]),
                  _createElementVNode("div", _hoisted_33, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(headersList.value, (_, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "flex items-center gap-3"
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": ($event: any) => ((headersList.value[index].key) = $event),
                          type: "text",
                          class: "flex-1 px-4 py-2.5 border rounded-xl text-sm font-mono focus:outline-none focus:ring-2 bg-white dark:bg-gray-700 border-gray-300 dark:border-gray-600 text-gray-900 dark:text-white focus:ring-emerald-500 focus:border-emerald-500 transition-all",
                          placeholder: "Header name"
                        }, null, 8, _hoisted_34), [
                          [_vModelText, headersList.value[index].key]
                        ]),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": ($event: any) => ((headersList.value[index].value) = $event),
                          type: "text",
                          class: "flex-1 px-4 py-2.5 border rounded-xl text-sm font-mono focus:outline-none focus:ring-2 bg-white dark:bg-gray-700 border-gray-300 dark:border-gray-600 text-gray-900 dark:text-white focus:ring-emerald-500 focus:border-emerald-500 transition-all",
                          placeholder: "Header value"
                        }, null, 8, _hoisted_35), [
                          [_vModelText, headersList.value[index].value]
                        ]),
                        _createElementVNode("button", {
                          type: "button",
                          class: "p-2 text-rose-500 hover:bg-rose-50 dark:hover:bg-rose-900/30 rounded-xl transition-colors",
                          onClick: ($event: any) => (removeHeader(index))
                        }, _cache[63] || (_cache[63] = [
                          _createElementVNode("svg", {
                            class: "w-5 h-5",
                            fill: "none",
                            stroke: "currentColor",
                            viewBox: "0 0 24 24"
                          }, [
                            _createElementVNode("path", {
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              "stroke-width": "2",
                              d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                            })
                          ], -1)
                        ]), 8, _hoisted_36)
                      ]))
                    }), 128)),
                    (headersList.value.length === 0)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_37, " No headers added yet "))
                      : _createCommentVNode("", true)
                  ])
                ]),
                (['POST', 'PUT', 'PATCH'].includes(form.source.config.method))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                      _cache[64] || (_cache[64] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2" }, " Request Body (JSON) ", -1)),
                      _withDirectives(_createElementVNode("textarea", {
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((bodyJson).value = $event)),
                        rows: "5",
                        class: "w-full px-4 py-3 border rounded-xl text-sm font-mono focus:outline-none focus:ring-2 bg-white dark:bg-gray-700 border-gray-300 dark:border-gray-600 text-gray-900 dark:text-white focus:ring-emerald-500 focus:border-emerald-500 transition-all",
                        placeholder: "{\"key\": \"value\"}"
                      }, null, 512), [
                        [_vModelText, bodyJson.value]
                      ]),
                      (bodyJsonError.value)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_39, _toDisplayString(bodyJsonError.value), 1))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ], 512), [
              [_vShow, sections.source]
            ])
          ]),
          _: 1
        })
      ], 2),
      _createVNode(_Transition, {
        "enter-active-class": "transition-all duration-300 ease-out",
        "enter-from-class": "opacity-0 translate-x-4 w-0",
        "enter-to-class": "opacity-100 translate-x-0 w-[40%]",
        "leave-active-class": "transition-all duration-200 ease-in",
        "leave-from-class": "opacity-100 translate-x-0 w-[40%]",
        "leave-to-class": "opacity-0 translate-x-4 w-0"
      }, {
        default: _withCtx(() => [
          (showSourcePreview.value || sourcePreviewError.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass([
            _unref(theme).isDark.value ? 'bg-gray-800' : 'bg-white',
            'rounded-2xl overflow-hidden shadow-lg-custom w-[40%] flex-shrink-0'
          ]),
                style: {"box-shadow":"var(--shadow-lg)"}
              }, [
                _createElementVNode("div", _hoisted_40, [
                  _cache[66] || (_cache[66] = _createElementVNode("h4", { class: "text-sm font-semibold text-gray-900 dark:text-white flex items-center" }, [
                    _createElementVNode("svg", {
                      class: "w-4 h-4 mr-2 text-blue-500",
                      fill: "none",
                      stroke: "currentColor",
                      viewBox: "0 0 24 24"
                    }, [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                      }),
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                      })
                    ]),
                    _createTextVNode(" Source Preview ")
                  ], -1)),
                  _createElementVNode("button", {
                    type: "button",
                    class: "p-1.5 text-gray-500 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg transition-colors",
                    onClick: _cache[11] || (_cache[11] = () => {
                showSourcePreview.value = false
                sourcePreviewData.value = null
                sourcePreviewError.value = null
              })
                  }, _cache[65] || (_cache[65] = [
                    _createElementVNode("svg", {
                      class: "w-4 h-4",
                      fill: "none",
                      stroke: "currentColor",
                      viewBox: "0 0 24 24"
                    }, [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M6 18L18 6M6 6l12 12"
                      })
                    ], -1)
                  ]))
                ]),
                _createElementVNode("div", _hoisted_41, [
                  (sourcePreviewError.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                        _createElementVNode("div", _hoisted_43, [
                          _cache[68] || (_cache[68] = _createElementVNode("svg", {
                            class: "w-5 h-5 text-rose-500 mt-0.5 mr-3 flex-shrink-0",
                            fill: "none",
                            stroke: "currentColor",
                            viewBox: "0 0 24 24"
                          }, [
                            _createElementVNode("path", {
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              "stroke-width": "2",
                              d: "M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                            })
                          ], -1)),
                          _createElementVNode("div", _hoisted_44, [
                            _cache[67] || (_cache[67] = _createElementVNode("p", { class: "text-sm font-medium text-rose-700 dark:text-rose-300" }, "Preview Error", -1)),
                            _createElementVNode("p", _hoisted_45, _toDisplayString(sourcePreviewError.value), 1)
                          ])
                        ])
                      ]))
                    : (sourcePreviewData.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                          _createElementVNode("div", _hoisted_47, [
                            _createElementVNode("span", _hoisted_48, [
                              _cache[69] || (_cache[69] = _createTextVNode(" Stage: ")),
                              _createElementVNode("span", _hoisted_49, _toDisplayString(sourcePreviewData.value.stage), 1)
                            ]),
                            _createElementVNode("span", {
                              class: _normalizeClass([
                    sourcePreviewData.value.success
                      ? 'text-emerald-600 dark:text-emerald-400'
                      : 'text-rose-600 dark:text-rose-400',
                    'text-xs font-medium'
                  ])
                            }, _toDisplayString(sourcePreviewData.value.success ? 'Success' : 'Failed'), 3)
                          ]),
                          _createElementVNode("pre", _hoisted_50, _toDisplayString(JSON.stringify(sourcePreviewData.value.data, null, 2)), 1)
                        ]))
                      : _createCommentVNode("", true)
                ])
              ], 2))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_51, [
      _createElementVNode("div", {
        class: _normalizeClass([
          _unref(theme).isDark.value ? 'bg-gray-800' : 'bg-white',
          'rounded-2xl overflow-hidden shadow-lg-custom transition-all duration-300',
          showTransformPreview.value ? 'w-[550px] flex-shrink-0' : 'flex-1'
        ]),
        style: {"box-shadow":"var(--shadow-lg)"}
      }, [
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass(["w-full px-6 py-4 flex items-center justify-between border-b transition-colors", [
            _unref(theme).isDark.value
              ? 'border-gray-700 hover:bg-gray-700/50'
              : 'border-gray-100 hover:bg-gray-50'
          ]]),
          onClick: _cache[12] || (_cache[12] = ($event: any) => (sections.template = !sections.template))
        }, [
          _cache[74] || (_cache[74] = _createStaticVNode("<div class=\"flex items-center\"><div class=\"p-2.5 bg-violet-100 dark:bg-violet-900/30 rounded-xl mr-4\"><svg class=\"w-6 h-6 text-violet-500\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M8 9l3 3-3 3m5 0h3M5 20h14a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z\"></path></svg></div><div class=\"text-left\"><h3 class=\"text-lg font-semibold text-gray-900 dark:text-white\">Template</h3><p class=\"text-sm text-gray-500 dark:text-gray-400\"> Handlebars message template configuration </p></div></div>", 1)),
          _createElementVNode("div", _hoisted_52, [
            (fileConfigEnabled.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_53, " PDF/File Enabled "))
              : _createCommentVNode("", true),
            (
                FEATURE_TOGGLES.ENABLE_TRANSFORM_PREVIEW && _ctx.mode === 'edit' && props.reportData?.id
              )
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  type: "button",
                  class: "flex items-center space-x-1.5 px-3 py-1.5 text-xs font-medium text-violet-600 dark:text-violet-400 bg-violet-50 dark:bg-violet-900/20 hover:bg-violet-100 dark:hover:bg-violet-900/40 border border-violet-200 dark:border-violet-700 rounded-lg transition-all duration-200",
                  disabled: transformPreviewLoading.value,
                  onClick: _withModifiers(previewTransformStage, ["stop"])
                }, [
                  (transformPreviewLoading.value)
                    ? (_openBlock(), _createElementBlock("svg", _hoisted_55, _cache[70] || (_cache[70] = [
                        _createElementVNode("circle", {
                          class: "opacity-25",
                          cx: "12",
                          cy: "12",
                          r: "10",
                          stroke: "currentColor",
                          "stroke-width": "4"
                        }, null, -1),
                        _createElementVNode("path", {
                          class: "opacity-75",
                          fill: "currentColor",
                          d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                        }, null, -1)
                      ])))
                    : (_openBlock(), _createElementBlock("svg", _hoisted_56, _cache[71] || (_cache[71] = [
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2",
                          d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                        }, null, -1),
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2",
                          d: "M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                        }, null, -1)
                      ]))),
                  _cache[72] || (_cache[72] = _createElementVNode("span", null, "Preview", -1))
                ], 8, _hoisted_54))
              : _createCommentVNode("", true),
            (_openBlock(), _createElementBlock("svg", {
              class: _normalizeClass([
                'w-5 h-5 text-gray-400 transition-transform duration-200',
                sections.template ? 'rotate-180' : ''
              ]),
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, _cache[73] || (_cache[73] = [
              _createElementVNode("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M19 9l-7 7-7-7"
              }, null, -1)
            ]), 2))
          ])
        ], 2),
        _createVNode(_Transition, {
          "enter-active-class": "transition-all duration-300 ease-out",
          "enter-from-class": "opacity-0 max-h-0",
          "enter-to-class": "opacity-100 max-h-[2000px]",
          "leave-active-class": "transition-all duration-200 ease-in",
          "leave-from-class": "opacity-100 max-h-[2000px]",
          "leave-to-class": "opacity-0 max-h-0"
        }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("div", _hoisted_57, [
              _createElementVNode("div", _hoisted_58, [
                _createElementVNode("div", null, [
                  _cache[75] || (_cache[75] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2" }, [
                    _createTextVNode(" Message Template "),
                    _createElementVNode("span", { class: "text-rose-500" }, "*")
                  ], -1)),
                  _withDirectives(_createElementVNode("textarea", {
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((form.transform.config.template) = $event)),
                    required: "",
                    rows: "8",
                    class: "w-full px-4 py-3 border rounded-xl text-sm font-mono focus:outline-none focus:ring-2 bg-white dark:bg-gray-700 border-gray-300 dark:border-gray-600 text-gray-900 dark:text-white focus:ring-emerald-500 focus:border-emerald-500 transition-all",
                    placeholder: "*Daily Report* :chart_with_upwards_trend:\n\n{{#each items}}\n• *{{name}}*: {{value}}\n{{/each}}\n\n_Generated at {{timestamp}}_"
                  }, null, 512), [
                    [_vModelText, form.transform.config.template]
                  ]),
                  _cache[76] || (_cache[76] = _createElementVNode("p", { class: "mt-2 text-xs text-gray-500 dark:text-gray-400" }, [
                    _createTextVNode(" Use Handlebars syntax to reference data from your API response. All variables automatically point to "),
                    _createElementVNode("code", { class: "px-1.5 py-0.5 bg-gray-100 dark:bg-gray-700 rounded-md" }, "data.value"),
                    _createTextVNode(" from the response, so you can access nested properties directly. For example, if your API returns "),
                    _createElementVNode("code", { class: "px-1.5 py-0.5 bg-gray-100 dark:bg-gray-700 rounded-md" }, "data.value.message"),
                    _createTextVNode(", simply use "),
                    _createElementVNode("code", { class: "px-1.5 py-0.5 bg-gray-100 dark:bg-gray-700 rounded-md" }, "{{message}}"),
                    _createTextVNode(" in your template. ")
                  ], -1))
                ]),
                _createElementVNode("div", _hoisted_59, [
                  _cache[77] || (_cache[77] = _createElementVNode("div", null, [
                    _createElementVNode("span", { class: "text-sm font-medium text-gray-700 dark:text-gray-300" }, "Enable PDF/File Generation"),
                    _createElementVNode("p", { class: "text-xs text-gray-500 dark:text-gray-400 mt-1" }, " Generate and attach a PDF or CSV file ")
                  ], -1)),
                  _createElementVNode("button", {
                    type: "button",
                    class: _normalizeClass([
                    fileConfigEnabled.value ? 'bg-emerald-500' : 'bg-gray-300 dark:bg-gray-600',
                    'relative inline-flex h-7 w-12 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:ring-offset-2'
                  ]),
                    onClick: _cache[14] || (_cache[14] = ($event: any) => (fileConfigEnabled.value = !fileConfigEnabled.value))
                  }, [
                    _createElementVNode("span", {
                      class: _normalizeClass([
                      fileConfigEnabled.value ? 'translate-x-5' : 'translate-x-0',
                      'pointer-events-none inline-block h-6 w-6 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out'
                    ])
                    }, null, 2)
                  ], 2)
                ]),
                (fileConfigEnabled.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                      _cache[94] || (_cache[94] = _createElementVNode("h5", { class: "text-sm font-medium text-gray-700 dark:text-gray-300 flex items-center" }, [
                        _createElementVNode("span", { class: "text-lg mr-2" }, "📎"),
                        _createTextVNode(" File Generation Configuration "),
                        _createElementVNode("span", { class: "ml-2 text-xs font-normal text-gray-500 dark:text-gray-400" }, "(Optional - defaults will be used if not specified)")
                      ], -1)),
                      _createElementVNode("div", _hoisted_61, [
                        _createElementVNode("div", null, [
                          _cache[78] || (_cache[78] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2" }, " Data Path ", -1)),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((form.transform.config.fileConfig!.dataPath) = $event)),
                            type: "text",
                            class: "w-full px-4 py-3 border rounded-xl text-sm font-mono focus:outline-none focus:ring-2 bg-white dark:bg-gray-700 border-gray-300 dark:border-gray-600 text-gray-900 dark:text-white focus:ring-emerald-500 focus:border-emerald-500 transition-all",
                            placeholder: "data.value"
                          }, null, 512), [
                            [_vModelText, form.transform.config.fileConfig!.dataPath]
                          ]),
                          _cache[79] || (_cache[79] = _createElementVNode("p", { class: "mt-1 text-xs text-gray-500 dark:text-gray-400" }, [
                            _createTextVNode(" JSONPath to extract array from the API response. Points to "),
                            _createElementVNode("code", { class: "px-1 py-0.5 bg-gray-200 dark:bg-gray-600 rounded" }, "data.value"),
                            _createTextVNode(" by default. If your response contains an array at "),
                            _createElementVNode("code", { class: "px-1 py-0.5 bg-gray-200 dark:bg-gray-600 rounded" }, "data.value.results"),
                            _createTextVNode(", you can reference it in your template using "),
                            _createElementVNode("code", { class: "px-1 py-0.5 bg-gray-200 dark:bg-gray-600 rounded" }, "{{results}}"),
                            _createTextVNode(". ")
                          ], -1))
                        ]),
                        _createElementVNode("div", null, [
                          _cache[80] || (_cache[80] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2" }, " Top N Rows ", -1)),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((form.transform.config.fileConfig!.topN) = $event)),
                            type: "number",
                            min: "1",
                            max: "1000",
                            class: "w-full px-4 py-3 border rounded-xl text-sm focus:outline-none focus:ring-2 bg-white dark:bg-gray-700 border-gray-300 dark:border-gray-600 text-gray-900 dark:text-white focus:ring-emerald-500 focus:border-emerald-500 transition-all",
                            placeholder: "20"
                          }, null, 512), [
                            [
                              _vModelText,
                              form.transform.config.fileConfig!.topN,
                              void 0,
                              { number: true }
                            ]
                          ]),
                          _cache[81] || (_cache[81] = _createElementVNode("p", { class: "mt-1 text-xs text-gray-500 dark:text-gray-400" }, [
                            _createTextVNode(" Default: "),
                            _createElementVNode("code", { class: "px-1 py-0.5 bg-gray-200 dark:bg-gray-600 rounded" }, "20")
                          ], -1))
                        ])
                      ]),
                      _createElementVNode("div", null, [
                        _cache[82] || (_cache[82] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2" }, " Column Headers ", -1)),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((fileConfigHeaders).value = $event)),
                          type: "text",
                          class: "w-full px-4 py-3 border rounded-xl text-sm font-mono focus:outline-none focus:ring-2 bg-white dark:bg-gray-700 border-gray-300 dark:border-gray-600 text-gray-900 dark:text-white focus:ring-emerald-500 focus:border-emerald-500 transition-all",
                          placeholder: "Auto-detected from first result object"
                        }, null, 512), [
                          [_vModelText, fileConfigHeaders.value]
                        ]),
                        _cache[83] || (_cache[83] = _createElementVNode("p", { class: "mt-1 text-xs text-gray-500 dark:text-gray-400" }, " Comma-separated list. Leave empty to auto-detect from first JSON object keys ", -1))
                      ]),
                      _createElementVNode("div", _hoisted_62, [
                        _createElementVNode("div", null, [
                          _cache[84] || (_cache[84] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2" }, " Sort By Columns ", -1)),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((sortColumns).value = $event)),
                            type: "text",
                            class: "w-full px-4 py-3 border rounded-xl text-sm font-mono focus:outline-none focus:ring-2 bg-white dark:bg-gray-700 border-gray-300 dark:border-gray-600 text-gray-900 dark:text-white focus:ring-emerald-500 focus:border-emerald-500 transition-all",
                            placeholder: "e.g., count, name"
                          }, null, 512), [
                            [_vModelText, sortColumns.value]
                          ]),
                          _cache[85] || (_cache[85] = _createElementVNode("p", { class: "mt-1 text-xs text-gray-500 dark:text-gray-400" }, " Comma-separated column names (in priority order). Leave empty for no sorting ", -1))
                        ]),
                        _createElementVNode("div", null, [
                          _cache[87] || (_cache[87] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2" }, " Sort Order ", -1)),
                          _withDirectives(_createElementVNode("select", {
                            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((sortOrder).value = $event)),
                            class: "w-full px-4 py-3 border rounded-xl text-sm focus:outline-none focus:ring-2 bg-white dark:bg-gray-700 border-gray-300 dark:border-gray-600 text-gray-900 dark:text-white focus:ring-emerald-500 focus:border-emerald-500 transition-all"
                          }, _cache[86] || (_cache[86] = [
                            _createElementVNode("option", { value: "desc" }, "Descending (High to Low)", -1),
                            _createElementVNode("option", { value: "asc" }, "Ascending (Low to High)", -1)
                          ]), 512), [
                            [_vModelSelect, sortOrder.value]
                          ]),
                          _cache[88] || (_cache[88] = _createElementVNode("p", { class: "mt-1 text-xs text-gray-500 dark:text-gray-400" }, [
                            _createTextVNode(" Default: "),
                            _createElementVNode("code", { class: "px-1 py-0.5 bg-gray-200 dark:bg-gray-600 rounded" }, "desc")
                          ], -1))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_63, [
                        _cache[93] || (_cache[93] = _createElementVNode("h6", { class: "text-sm font-medium text-gray-700 dark:text-gray-300 mb-4 flex items-center" }, [
                          _createElementVNode("span", { class: "text-lg mr-2" }, "📎"),
                          _createTextVNode(" File Attachment Settings ")
                        ], -1)),
                        _createElementVNode("div", _hoisted_64, [
                          _createElementVNode("div", null, [
                            _cache[89] || (_cache[89] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2" }, [
                              _createTextVNode(" Filename "),
                              _createElementVNode("span", { class: "text-rose-500" }, "*")
                            ], -1)),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((form.sink.config.file!.filename) = $event)),
                              type: "text",
                              class: "w-full px-4 py-3 border rounded-xl text-sm focus:outline-none focus:ring-2 bg-white dark:bg-gray-700 border-gray-300 dark:border-gray-600 text-gray-900 dark:text-white focus:ring-emerald-500 focus:border-emerald-500 transition-all",
                              placeholder: "report.pdf"
                            }, null, 512), [
                              [_vModelText, form.sink.config.file!.filename]
                            ])
                          ]),
                          _createElementVNode("div", null, [
                            _cache[90] || (_cache[90] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2" }, " File Title ", -1)),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((form.sink.config.file!.title) = $event)),
                              type: "text",
                              class: "w-full px-4 py-3 border rounded-xl text-sm focus:outline-none focus:ring-2 bg-white dark:bg-gray-700 border-gray-300 dark:border-gray-600 text-gray-900 dark:text-white focus:ring-emerald-500 focus:border-emerald-500 transition-all",
                              placeholder: "Weekly Report"
                            }, null, 512), [
                              [_vModelText, form.sink.config.file!.title]
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_65, [
                          _createElementVNode("div", null, [
                            _cache[91] || (_cache[91] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2" }, " Before Content ", -1)),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((form.sink.config.file!.beforeContent) = $event)),
                              type: "text",
                              class: "w-full px-4 py-3 border rounded-xl text-sm focus:outline-none focus:ring-2 bg-white dark:bg-gray-700 border-gray-300 dark:border-gray-600 text-gray-900 dark:text-white focus:ring-emerald-500 focus:border-emerald-500 transition-all",
                              placeholder: "Text before the table"
                            }, null, 512), [
                              [_vModelText, form.sink.config.file!.beforeContent]
                            ])
                          ]),
                          _createElementVNode("div", null, [
                            _cache[92] || (_cache[92] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2" }, " After Content ", -1)),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((form.sink.config.file!.afterContent) = $event)),
                              type: "text",
                              class: "w-full px-4 py-3 border rounded-xl text-sm focus:outline-none focus:ring-2 bg-white dark:bg-gray-700 border-gray-300 dark:border-gray-600 text-gray-900 dark:text-white focus:ring-emerald-500 focus:border-emerald-500 transition-all",
                              placeholder: "Text after the table"
                            }, null, 512), [
                              [_vModelText, form.sink.config.file!.afterContent]
                            ])
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ], 512), [
              [_vShow, sections.template]
            ])
          ]),
          _: 1
        })
      ], 2),
      _createVNode(_Transition, {
        "enter-active-class": "transition-all duration-300 ease-out",
        "enter-from-class": "opacity-0 translate-x-4 w-0",
        "enter-to-class": "opacity-100 translate-x-0 flex-1",
        "leave-active-class": "transition-all duration-200 ease-in",
        "leave-from-class": "opacity-100 translate-x-0 flex-1",
        "leave-to-class": "opacity-0 translate-x-4 w-0"
      }, {
        default: _withCtx(() => [
          (showTransformPreview.value || transformPreviewError.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass([
            _unref(theme).isDark.value ? 'bg-gray-800' : 'bg-white',
            'rounded-2xl overflow-hidden shadow-lg-custom flex-1 min-w-[400px]'
          ]),
                style: {"box-shadow":"var(--shadow-lg)"}
              }, [
                _createElementVNode("div", _hoisted_66, [
                  _cache[96] || (_cache[96] = _createElementVNode("h4", { class: "text-sm font-semibold text-gray-900 dark:text-white flex items-center" }, [
                    _createElementVNode("svg", {
                      class: "w-4 h-4 mr-2 text-violet-500",
                      fill: "none",
                      stroke: "currentColor",
                      viewBox: "0 0 24 24"
                    }, [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                      }),
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                      })
                    ]),
                    _createTextVNode(" Transform Preview ")
                  ], -1)),
                  _createElementVNode("button", {
                    type: "button",
                    class: "p-1.5 text-gray-500 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg transition-colors",
                    onClick: _cache[24] || (_cache[24] = () => {
                showTransformPreview.value = false
                transformPreviewData.value = null
                transformPreviewError.value = null
              })
                  }, _cache[95] || (_cache[95] = [
                    _createElementVNode("svg", {
                      class: "w-4 h-4",
                      fill: "none",
                      stroke: "currentColor",
                      viewBox: "0 0 24 24"
                    }, [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M6 18L18 6M6 6l12 12"
                      })
                    ], -1)
                  ]))
                ]),
                _createElementVNode("div", _hoisted_67, [
                  (transformPreviewError.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                        _createElementVNode("div", _hoisted_69, [
                          _createElementVNode("div", _hoisted_70, [
                            _cache[98] || (_cache[98] = _createElementVNode("svg", {
                              class: "w-5 h-5 text-rose-500 mt-0.5 mr-3 flex-shrink-0",
                              fill: "none",
                              stroke: "currentColor",
                              viewBox: "0 0 24 24"
                            }, [
                              _createElementVNode("path", {
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                "stroke-width": "2",
                                d: "M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                              })
                            ], -1)),
                            _createElementVNode("div", _hoisted_71, [
                              _cache[97] || (_cache[97] = _createElementVNode("p", { class: "text-sm font-medium text-rose-700 dark:text-rose-300" }, " Preview Error ", -1)),
                              _createElementVNode("p", _hoisted_72, _toDisplayString(transformPreviewError.value), 1)
                            ])
                          ])
                        ])
                      ]))
                    : (transformPreviewData.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                          _createElementVNode("div", _hoisted_74, [
                            _createElementVNode("div", _hoisted_75, [
                              _cache[100] || (_cache[100] = _createElementVNode("div", { class: "w-9 h-9 rounded-lg bg-[#4A154B] flex items-center justify-center" }, [
                                _createElementVNode("svg", {
                                  class: "w-5 h-5 text-white",
                                  viewBox: "0 0 24 24",
                                  fill: "currentColor"
                                }, [
                                  _createElementVNode("path", { d: "M5.042 15.165a2.528 2.528 0 0 1-2.52 2.523A2.528 2.528 0 0 1 0 15.165a2.527 2.527 0 0 1 2.522-2.52h2.52v2.52zM6.313 15.165a2.527 2.527 0 0 1 2.521-2.52 2.527 2.527 0 0 1 2.521 2.52v6.313A2.528 2.528 0 0 1 8.834 24a2.528 2.528 0 0 1-2.521-2.522v-6.313zM8.834 5.042a2.528 2.528 0 0 1-2.521-2.52A2.528 2.528 0 0 1 8.834 0a2.528 2.528 0 0 1 2.521 2.522v2.52H8.834zM8.834 6.313a2.528 2.528 0 0 1 2.521 2.521 2.528 2.528 0 0 1-2.521 2.521H2.522A2.528 2.528 0 0 1 0 8.834a2.528 2.528 0 0 1 2.522-2.521h6.312zM18.956 8.834a2.528 2.528 0 0 1 2.522-2.521A2.528 2.528 0 0 1 24 8.834a2.528 2.528 0 0 1-2.522 2.521h-2.522V8.834zM17.688 8.834a2.528 2.528 0 0 1-2.523 2.521 2.527 2.527 0 0 1-2.52-2.521V2.522A2.527 2.527 0 0 1 15.165 0a2.528 2.528 0 0 1 2.523 2.522v6.312zM15.165 18.956a2.528 2.528 0 0 1 2.523 2.522A2.528 2.528 0 0 1 15.165 24a2.527 2.527 0 0 1-2.52-2.522v-2.522h2.52zM15.165 17.688a2.527 2.527 0 0 1-2.52-2.523 2.526 2.526 0 0 1 2.52-2.52h6.313A2.527 2.527 0 0 1 24 15.165a2.528 2.528 0 0 1-2.522 2.523h-6.313z" })
                                ])
                              ], -1)),
                              _createElementVNode("div", null, [
                                _cache[99] || (_cache[99] = _createElementVNode("div", { class: "flex items-center space-x-2" }, [
                                  _createElementVNode("span", { class: "text-white font-bold text-sm" }, "Slack Preview"),
                                  _createElementVNode("span", { class: "px-1.5 py-0.5 text-[10px] font-medium bg-gray-600 text-gray-300 rounded" }, "APP")
                                ], -1)),
                                _createElementVNode("span", _hoisted_76, _toDisplayString(new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })), 1)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_77, [
                              _createElementVNode("div", {
                                class: "text-[15px] text-gray-100 leading-relaxed slack-message-preview",
                                innerHTML: formatSlackMessage(String(transformPreviewData.value.data?.message || ''))
                              }, null, 8, _hoisted_78)
                            ]),
                            (getFileData(transformPreviewData.value.data))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                                  _createElementVNode("div", _hoisted_80, [
                                    _cache[101] || (_cache[101] = _createElementVNode("div", { class: "flex items-center space-x-2" }, [
                                      _createElementVNode("svg", {
                                        class: "w-4 h-4 text-red-500",
                                        fill: "currentColor",
                                        viewBox: "0 0 24 24"
                                      }, [
                                        _createElementVNode("path", { d: "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zM6 20V4h7v5h5v11H6z" }),
                                        _createElementVNode("path", { d: "M8 12h8v1H8zm0 2h8v1H8zm0 2h5v1H8z" })
                                      ]),
                                      _createElementVNode("span", { class: "text-xs font-medium text-gray-300" }, "PDF Preview")
                                    ], -1)),
                                    _createElementVNode("span", _hoisted_81, _toDisplayString(getFileDataRowCount(transformPreviewData.value.data)) + " rows total", 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_82, [
                                    (getSinkFileConfig().title)
                                      ? (_openBlock(), _createElementBlock("h2", _hoisted_83, _toDisplayString(getSinkFileConfig().title), 1))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("p", _hoisted_84, " Generated: " + _toDisplayString(new Date().toISOString()), 1),
                                    (getSinkFileConfig().beforeContent)
                                      ? (_openBlock(), _createElementBlock("p", _hoisted_85, _toDisplayString(getSinkFileConfig().beforeContent), 1))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("div", _hoisted_86, [
                                      _createElementVNode("table", _hoisted_87, [
                                        _createElementVNode("thead", null, [
                                          _createElementVNode("tr", _hoisted_88, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getFileDataHeaders(transformPreviewData.value.data), (header) => {
                                              return (_openBlock(), _createElementBlock("th", {
                                                key: header,
                                                class: "px-4 py-2.5 text-left text-xs font-semibold text-white capitalize border border-[#4472C4]"
                                              }, _toDisplayString(header), 1))
                                            }), 128))
                                          ])
                                        ]),
                                        _createElementVNode("tbody", null, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getFileDataRows(
                              transformPreviewData.value.data,
                              showAllPdfRows.value ? 20 : 5
                            ), (row, index) => {
                                            return (_openBlock(), _createElementBlock("tr", {
                                              key: index,
                                              class: _normalizeClass(index % 2 === 0 ? 'bg-white' : 'bg-gray-50')
                                            }, [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getFileDataHeaders(transformPreviewData.value.data), (header) => {
                                                return (_openBlock(), _createElementBlock("td", {
                                                  key: header,
                                                  class: "px-4 py-2 text-gray-900 border border-gray-200 break-words"
                                                }, _toDisplayString(typeof row[header] === 'number'
                                  ? row[header].toLocaleString()
                                  : row[header]), 1))
                                              }), 128))
                                            ], 2))
                                          }), 128))
                                        ])
                                      ])
                                    ]),
                                    (getFileDataRowCount(transformPreviewData.value.data) > 5)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_89, [
                                          _createElementVNode("button", {
                                            type: "button",
                                            class: "text-xs text-blue-600 hover:text-blue-800 font-medium",
                                            onClick: _cache[25] || (_cache[25] = ($event: any) => (showAllPdfRows.value = !showAllPdfRows.value))
                                          }, _toDisplayString(showAllPdfRows.value
                            ? 'Show less'
                            : `Show more (up to 20 of ${getFileDataRowCount(transformPreviewData.value.data)})`), 1)
                                        ]))
                                      : _createCommentVNode("", true),
                                    (getSinkFileConfig().afterContent)
                                      ? (_openBlock(), _createElementBlock("p", _hoisted_90, _toDisplayString(getSinkFileConfig().afterContent), 1))
                                      : _createCommentVNode("", true)
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_91, [
                            _createElementVNode("span", null, [
                              _cache[102] || (_cache[102] = _createTextVNode("Stage: ")),
                              _createElementVNode("span", _hoisted_92, _toDisplayString(transformPreviewData.value.stage), 1)
                            ]),
                            _createElementVNode("span", {
                              class: _normalizeClass(
                    transformPreviewData.value.success
                      ? 'text-emerald-600 dark:text-emerald-400'
                      : 'text-rose-600 dark:text-rose-400'
                  )
                            }, _toDisplayString(transformPreviewData.value.success ? 'Success' : 'Failed'), 3)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                ])
              ], 2))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", {
      class: _normalizeClass([
        _unref(theme).isDark.value ? 'bg-gray-800' : 'bg-white',
        'rounded-2xl overflow-hidden shadow-lg-custom'
      ]),
      style: {"box-shadow":"var(--shadow-lg)"}
    }, [
      _createElementVNode("button", {
        type: "button",
        class: _normalizeClass(["w-full px-6 py-4 flex items-center justify-between border-b transition-colors", [
          _unref(theme).isDark.value
            ? 'border-gray-700 hover:bg-gray-700/50'
            : 'border-gray-100 hover:bg-gray-50'
        ]]),
        onClick: _cache[26] || (_cache[26] = ($event: any) => (sections.sink = !sections.sink))
      }, [
        _cache[104] || (_cache[104] = _createStaticVNode("<div class=\"flex items-center\"><div class=\"p-2.5 bg-emerald-100 dark:bg-emerald-900/30 rounded-xl mr-4\"><svg class=\"w-6 h-6 text-emerald-500\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z\"></path></svg></div><div class=\"text-left\"><h3 class=\"text-lg font-semibold text-gray-900 dark:text-white\">Sink</h3><p class=\"text-sm text-gray-500 dark:text-gray-400\">Slack destination configuration</p></div></div>", 1)),
        _createElementVNode("div", _hoisted_93, [
          (form.sink.config.action)
            ? (_openBlock(), _createElementBlock("span", _hoisted_94, _toDisplayString(formatSinkAction(form.sink.config.action)), 1))
            : _createCommentVNode("", true),
          (_openBlock(), _createElementBlock("svg", {
            class: _normalizeClass([
              'w-5 h-5 text-gray-400 transition-transform duration-200',
              sections.sink ? 'rotate-180' : ''
            ]),
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, _cache[103] || (_cache[103] = [
            _createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M19 9l-7 7-7-7"
            }, null, -1)
          ]), 2))
        ])
      ], 2),
      _createVNode(_Transition, {
        "enter-active-class": "transition-all duration-300 ease-out",
        "enter-from-class": "opacity-0 max-h-0",
        "enter-to-class": "opacity-100 max-h-[2000px]",
        "leave-active-class": "transition-all duration-200 ease-in",
        "leave-from-class": "opacity-100 max-h-[2000px]",
        "leave-to-class": "opacity-0 max-h-0"
      }, {
        default: _withCtx(() => [
          _withDirectives(_createElementVNode("div", _hoisted_95, [
            _createElementVNode("div", _hoisted_96, [
              (FEATURE_TOGGLES.ENABLE_SLACK_URL_IMPORT_BUTTON)
                ? (_openBlock(), _createElementBlock("div", _hoisted_97, [
                    (!showSlackUrlInput.value)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "button",
                          class: "flex items-center space-x-2 px-4 py-2 text-sm font-medium text-emerald-600 dark:text-emerald-400 bg-emerald-50 dark:bg-emerald-900/20 hover:bg-emerald-100 dark:hover:bg-emerald-900/40 border border-emerald-200 dark:border-emerald-700 rounded-xl transition-all duration-200",
                          onClick: _cache[27] || (_cache[27] = ($event: any) => (showSlackUrlInput.value = true))
                        }, _cache[105] || (_cache[105] = [
                          _createElementVNode("svg", {
                            class: "w-4 h-4",
                            fill: "none",
                            stroke: "currentColor",
                            viewBox: "0 0 24 24"
                          }, [
                            _createElementVNode("path", {
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              "stroke-width": "2",
                              d: "M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"
                            })
                          ], -1),
                          _createElementVNode("span", null, "Import Slack URL", -1)
                        ])))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (showSlackUrlInput.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_98, [
                    _createElementVNode("div", _hoisted_99, [
                      _cache[107] || (_cache[107] = _createElementVNode("label", { class: "text-sm font-medium text-emerald-700 dark:text-emerald-300" }, " Paste Slack URL ", -1)),
                      _createElementVNode("button", {
                        type: "button",
                        class: "p-1.5 text-emerald-500 hover:text-emerald-700 dark:hover:text-emerald-300 hover:bg-emerald-100 dark:hover:bg-emerald-800/30 rounded-lg transition-colors",
                        onClick: _cache[28] || (_cache[28] = () => {
                    showSlackUrlInput.value = false
                    slackUrlInput.value = ''
                    slackUrlError.value = null
                  })
                      }, _cache[106] || (_cache[106] = [
                        _createElementVNode("svg", {
                          class: "w-4 h-4",
                          fill: "none",
                          stroke: "currentColor",
                          viewBox: "0 0 24 24"
                        }, [
                          _createElementVNode("path", {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2",
                            d: "M6 18L18 6M6 6l12 12"
                          })
                        ], -1)
                      ]))
                    ]),
                    _withDirectives(_createElementVNode("input", {
                      ref_key: "slackUrlInputRef",
                      ref: slackUrlInputRef,
                      "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((slackUrlInput).value = $event)),
                      type: "text",
                      class: "w-full px-4 py-3 border rounded-xl text-sm font-mono focus:outline-none focus:ring-2 bg-white dark:bg-gray-700 border-emerald-300 dark:border-emerald-600 text-gray-900 dark:text-white focus:ring-emerald-500 focus:border-emerald-500 transition-all",
                      placeholder: "https://gohighlevel.slack.com/archives/C097UPY34QJ",
                      onKeydown: _withKeys(_withModifiers(parseSlackUrl, ["prevent"]), ["enter"])
                    }, null, 40, _hoisted_100), [
                      [_vModelText, slackUrlInput.value]
                    ]),
                    (slackUrlError.value)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_101, _toDisplayString(slackUrlError.value), 1))
                      : _createCommentVNode("", true),
                    (slackUrlSuccess.value)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_102, _toDisplayString(slackUrlSuccess.value), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", { class: "flex items-center justify-between" }, [
                      _cache[108] || (_cache[108] = _createElementVNode("p", { class: "text-xs text-emerald-600 dark:text-emerald-400" }, " Supports: Channel, Thread, or DM URLs ", -1)),
                      _createElementVNode("button", {
                        type: "button",
                        class: "px-4 py-2 text-sm font-medium text-white bg-emerald-500 hover:bg-emerald-600 rounded-xl transition-colors",
                        onClick: parseSlackUrl
                      }, " Import ")
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_103, [
                _createElementVNode("div", null, [
                  _cache[110] || (_cache[110] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2" }, [
                    _createTextVNode(" Action "),
                    _createElementVNode("span", { class: "text-rose-500" }, "*")
                  ], -1)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((form.sink.config.action) = $event)),
                    class: "w-full px-4 py-3 border rounded-xl text-sm focus:outline-none focus:ring-2 bg-white dark:bg-gray-700 border-gray-300 dark:border-gray-600 text-gray-900 dark:text-white focus:ring-emerald-500 focus:border-emerald-500 transition-all"
                  }, _cache[109] || (_cache[109] = [
                    _createElementVNode("option", { value: "sendToDM" }, "Send to DM", -1),
                    _createElementVNode("option", { value: "sendToChannel" }, "Send to Channel", -1),
                    _createElementVNode("option", { value: "sendToThread" }, "Send to Thread", -1)
                  ]), 512), [
                    [_vModelSelect, form.sink.config.action]
                  ])
                ]),
                (form.sink.config.action === 'sendToDM')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_104, [
                      _cache[111] || (_cache[111] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2" }, " User ID(s) ", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((userIdsInput).value = $event)),
                        type: "text",
                        class: "w-full px-4 py-3 border rounded-xl text-sm font-mono focus:outline-none focus:ring-2 bg-white dark:bg-gray-700 border-gray-300 dark:border-gray-600 text-gray-900 dark:text-white focus:ring-emerald-500 focus:border-emerald-500 transition-all",
                        placeholder: "U12345678, or paste Slack channel/thread URL",
                        onPaste: _cache[32] || (_cache[32] = ($event: any) => (onSlackFieldPaste($event, 'userId'))),
                        onInput: clearSlackFieldMessages
                      }, null, 544), [
                        [_vModelText, userIdsInput.value]
                      ]),
                      _cache[112] || (_cache[112] = _createElementVNode("p", { class: "mt-1 text-xs text-gray-500 dark:text-gray-400" }, " User ID (starts with U), or paste a Slack channel/thread URL to auto-extract ", -1))
                    ]))
                  : _createCommentVNode("", true),
                (
                  form.sink.config.action === 'sendToChannel' ||
                  form.sink.config.action === 'sendToThread'
                )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_105, [
                      _cache[113] || (_cache[113] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2" }, [
                        _createTextVNode(" Channel ID "),
                        _createElementVNode("span", { class: "text-rose-500" }, "*")
                      ], -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((form.sink.config.channelId) = $event)),
                        type: "text",
                        class: "w-full px-4 py-3 border rounded-xl text-sm font-mono focus:outline-none focus:ring-2 bg-white dark:bg-gray-700 border-gray-300 dark:border-gray-600 text-gray-900 dark:text-white focus:ring-emerald-500 focus:border-emerald-500 transition-all",
                        placeholder: "C12345678, or paste Slack channel URL",
                        onPaste: _cache[34] || (_cache[34] = ($event: any) => (onSlackFieldPaste($event, 'channelId'))),
                        onInput: clearSlackFieldMessages
                      }, null, 544), [
                        [_vModelText, form.sink.config.channelId]
                      ]),
                      _cache[114] || (_cache[114] = _createElementVNode("p", { class: "mt-1 text-xs text-gray-500 dark:text-gray-400" }, " Channel ID or paste a Slack URL to auto-extract ", -1))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (form.sink.config.action === 'sendToThread')
                ? (_openBlock(), _createElementBlock("div", _hoisted_106, [
                    _cache[115] || (_cache[115] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2" }, [
                      _createTextVNode(" Thread Timestamp "),
                      _createElementVNode("span", { class: "text-rose-500" }, "*")
                    ], -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((form.sink.config.threadTs) = $event)),
                      type: "text",
                      class: "w-full px-4 py-3 border rounded-xl text-sm font-mono focus:outline-none focus:ring-2 bg-white dark:bg-gray-700 border-gray-300 dark:border-gray-600 text-gray-900 dark:text-white focus:ring-emerald-500 focus:border-emerald-500 transition-all",
                      placeholder: "1704700800.123456, or paste Slack thread URL",
                      onPaste: _cache[36] || (_cache[36] = ($event: any) => (onSlackFieldPaste($event, 'threadTs'))),
                      onInput: clearSlackFieldMessages
                    }, null, 544), [
                      [_vModelText, form.sink.config.threadTs]
                    ]),
                    _cache[116] || (_cache[116] = _createElementVNode("p", { class: "mt-1 text-xs text-gray-500 dark:text-gray-400" }, " Thread timestamp or paste a Slack thread URL to auto-extract ", -1))
                  ]))
                : _createCommentVNode("", true),
              (slackFieldError.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_107, [
                    _createElementVNode("p", _hoisted_108, _toDisplayString(slackFieldError.value), 1)
                  ]))
                : _createCommentVNode("", true),
              (slackFieldSuccess.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_109, [
                    _createElementVNode("p", _hoisted_110, " ✓ " + _toDisplayString(slackFieldSuccess.value), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 512), [
            [_vShow, sections.sink]
          ])
        ]),
        _: 1
      })
    ], 2),
    (submitError.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_111, [
          _createElementVNode("p", _hoisted_112, _toDisplayString(submitError.value), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass([
        _unref(theme).isDark.value ? 'bg-gray-800' : 'bg-white',
        'rounded-2xl overflow-hidden shadow-lg-custom px-6 py-5 flex justify-between items-center'
      ]),
      style: {"box-shadow":"var(--shadow-lg)"}
    }, [
      _createElementVNode("button", {
        type: "button",
        disabled: isSubmitting.value,
        class: _normalizeClass([
          _unref(theme).isDark.value
            ? 'bg-gray-600 hover:bg-gray-500 text-gray-200'
            : 'bg-gray-200 hover:bg-gray-300 text-gray-700',
          'px-6 py-2.5 rounded-xl text-sm font-medium transition-all duration-200',
          isSubmitting.value ? 'opacity-50 cursor-not-allowed' : ''
        ]),
        onClick: handleCancel
      }, " Cancel ", 10, _hoisted_113),
      _createElementVNode("button", {
        type: "submit",
        disabled: isSubmitting.value,
        class: _normalizeClass([
          'px-6 py-2.5 bg-emerald-500 hover:bg-emerald-600 text-white rounded-xl text-sm font-medium transition-all duration-200 flex items-center space-x-2',
          isSubmitting.value ? 'opacity-50 cursor-not-allowed' : ''
        ]),
        onClick: handleSubmit
      }, [
        (isSubmitting.value)
          ? (_openBlock(), _createElementBlock("svg", _hoisted_115, _cache[117] || (_cache[117] = [
              _createElementVNode("circle", {
                class: "opacity-25",
                cx: "12",
                cy: "12",
                r: "10",
                stroke: "currentColor",
                "stroke-width": "4"
              }, null, -1),
              _createElementVNode("path", {
                class: "opacity-75",
                fill: "currentColor",
                d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              }, null, -1)
            ])))
          : _createCommentVNode("", true),
        _createElementVNode("span", null, _toDisplayString(isSubmitting.value ? 'Saving...' : _ctx.mode === 'edit' ? 'Save Changes' : 'Create Report'), 1)
      ], 10, _hoisted_114)
    ], 2)
  ]))
}
}

})